/* tslint:disable */

// ====================================================
// START: Typescript template
// ====================================================

// ====================================================
// Scalars
// ====================================================

/** A type representing a formatted java.util.UUID */
export type Uuid = any;

/** A type representing a Locale such as en_US or fr_FR */
export type Locale = any;

/** A type representing a full protocol, host and path */
export type Url = any;

/** Built-in java.math.BigDecimal */
export type BigDecimal = any;

// ====================================================
// InputTypes
// ====================================================

/** The input BEX context used for identifying users, sites and other platform functions */
export interface ContextInput {
  /** Information regarding the application which triggered the query */
  clientInfo?: ClientInfoInput | null;
  /** Currency as Alphabetic ISO 4217 code e.g. 'USD'. Use if default currency for Locale needs to be overwritten. */
  currency?: string | null;
  /** Debugging context, such as Abacus overrides */
  debugContext?: DebugContextInput | null;
  /** Client/user Device information */
  device: DeviceInput;
  /** The Expedia Affiliate Partner ID */
  eapid?: number | null;
  /** Client/user information */
  identity: IdentityInput;
  /** The context locale, e.g. "en_US" */
  locale: Locale;
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: PrivacyTrackingState | null;
  /** The context Site ID, e.g. (70201 for Orbitz) */
  siteId: number;
}
/** Describe which application is invoking bex api */
export interface ClientInfoInput {
  /** Name of the application */
  name: string;
  /** Version of the application eg:18.10 or 5fbc9958 */
  version?: string | null;
}
/** Context used for debugging purposes, such as overriding Abacus experiments */
export interface DebugContextInput {
  /** Abacus exposure overrides to be applied */
  abacusOverrides: ExposureInput[];
  /** ALTER mode */
  alterMode?: AlterMode | null;
}
/** An exposure to an abacus experiment */
export interface ExposureInput {
  /** The experiment bucket of the exposure */
  bucket: number;
  /** The numeric Abacus ID for an experiment */
  id: string;
}
/** Device information */
export interface DeviceInput {
  type: DeviceType;
}
/** Identity information for a specific user or device */
export interface IdentityInput {
  /** The Expedia user authenticated state */
  authState?: AuthenticationState | null;
  /** The device ID (DUAID) */
  duaid: Uuid;
  /** The Expedia User ID */
  expUserId?: string | null;
  /** The user TUID */
  tuid?: string | null;
}

export interface CoordinatesInput {
  /** The latitude of the point in degrees */
  latitude: number;
  /** The longitude of the point in degrees */
  longitude: number;
}

export interface ActivityDateRangeInput {
  endDate: DateInput;

  startDate: DateInput;
}
/** A common date object */
export interface DateInput {
  /** The day of the month, e.g. `1` for the 1st */
  day: number;
  /** The numeric month, e.g. `1` for January */
  month: number;
  /** The four-digit year e.g. `1999` */
  year: number;
}
/** Activity search region information */
export interface ActivityDestinationInput {
  /** Coordinates of the region, used for region (city or multicity) resolution */
  coordinates?: CoordinatesInput | null;
  /** activity id proposed for pinning on LX-SRP */
  pinnedActivityId?: string | null;
  /** Gaia region ID of the search */
  regionId?: string | null;
  /** Name of the region, used for fuzzy resolution */
  regionName?: string | null;
  /** Gaia Region Type denoted by regionId, example HOTEL OR CITY */
  regionType?: string | null;
}
/** Activity marketing information to identify sem/seo traffic */
export interface ActivityMarketingInfoInput {
  /** Marketing channel type code. */
  mctc?: number | null;
  /** field which identifies sem channel */
  sem?: string | null;
  /** field which identifies semdtl value */
  semdtl?: string | null;
}
/** Dimensions for a presention object i.e. image or icon */
export interface DimensionsInput {
  density: number;

  height: number;

  width: number;
}

export interface ActivityOfferFilterInput {
  selections?: ActivitySelectedValueInput[] | null;

  tickets?: ActivityTicketInput[] | null;
}

export interface ActivitySelectedValueInput {
  id: string;

  value: string;
}

export interface ActivityTicketInput {
  code: string;

  count: number;
}
/** Separate a large list of results into multiple sublists */
export interface PaginationInput {
  /** Number of results to get past the starting index */
  size?: number | null;
  /** The inclusive 0-based starting index of the results. Defaults to 0 */
  startingIndex?: number | null;
}
/** Activity search filtering options */
export interface ActivitySearchFiltersInput {
  /** Filter results by user selected activity id from ESS activity Typeahead Suggestions. */
  activityId?: string | null;
  /** Filter results by activity category, supported with legacy categories */
  categories?: ActivityCategory[] | null;
  /** Filter results by activity category keys, supported with nested categories */
  categoryKeys?: string[] | null;
  /** Filter results by user provided free text search keyword */
  keyword?: string | null;
  /** Filter results by user regionId to support neighborhood filters */
  regionId?: string | null;

  selections?: ActivitySelectedValueInput[] | null;
}
/** Activity search region information */
export interface ActivityRegionInput {
  /** Full name of the region, used for exact resolution */
  fullRegionName?: string | null;
  /** Gaia region ID of the search */
  regionId: string;
  /** Name of the region, used for fuzzy resolution */
  regionName?: string | null;
}

export interface InsuranceShoppingRequestInput {
  /** TripId */
  tripId: Uuid;
}

export interface TripItemsInput {
  tripId: string;

  tripItemsIds: string[];
}

export interface PropertyDateRangeInput {
  checkInDate: DateInput;

  checkOutDate: DateInput;
}
/** Contains detailed geographic information like the Gaia region id as well as the property ids in the region for the property destination */
export interface DestinationInput {
  /** The Geo location of the region to search */
  coordinates?: CoordinatesInput | null;
  /** The property ID to use for region resolution (pinned search). */
  pinnedPropertyId?: string | null;
  /** List of property IDs to return search information for. */
  propertyIds?: string[] | null;
  /** The Gaia region ID of the search */
  regionId?: string | null;
  /** The name of the region ID, used for fuzzy resolution */
  regionName?: string | null;
}
/** Property search filtering options */
export interface PropertySearchFiltersInput {
  /** Filter results by available accessibility amenities. Example: [ROLL_IN_SHOWER] will return properties with a roll in shower */
  accessibility?: PropertyFilterAccessibility[] | null;
  /** Filter results by TAAP Agency business model. */
  agencyBusinessModels?: AgencyBusinessModel[] | null;
  /** Filter results by available amenities. Example: [POOL,WIFI] will return properties with a pool and wifi */
  amenities?: PropertyFilterAmenity[] | null;
  /** Filter results by the bedroom count. Only includes Vacation Rentals */
  bedroomFilter?: number[] | null;
  /** Filter results by chain id. Input supports a valid chain id */
  chain?: string | null;
  /** Filter results by TAAP commission tier. */
  commissionTiers?: CommissionTier[] | null;
  /** Filter results by Deals */
  deals?: DealType[] | null;
  /** Filter results by available meal plan. Example: FULL_BOARD will return properties with a full board */
  mealPlan?: MealPlanFilterAmenity[] | null;
  /** Filter results by neighborhood. Input supports a valid GAIA ID */
  neighborhood?: string | null;
  /** Filter results by the payment type. */
  paymentType?: PaymentType[] | null;
  /** Filter results by popular location. Input supports a valid coordinates combination string */
  poi?: string | null;
  /** Filter results by price. Can provide a min only, a max only, or a range. */
  price?: PriceRangeInput | null;
  /** PWA ONLY: Support for legacy PWA price buckets in the url. Use 'price' instead */
  priceBuckets?: number[] | null;
  /** Filter results by user provided string */
  propertyName?: string | null;
  /** Property syle filters */
  propertyStyles?: PropertyStyle[] | null;
  /** Filter results by average guest rating. Can provide a min only, a max only, or a range. */
  reviewScore?: ReviewScoreRangeInput | null;
  /** Rewards Type filters */
  rewards?: string[] | null;
  /** Filter results by availability */
  showAvailableOnly?: boolean | null;
  /** Filter results by property star rating. Example: 30, 50 returns properties rated 3 to 3.9 and 5 to 5.9 */
  starList?: number[] | null;
  /** Filter results by property star rating. Example: THREE returns properties rated 3.0+ */
  stars?: StarRangeInput | null;
  /** Filter results by structure type. Example: HOTEL returns properties of structure type 'HOTEL' */
  structureTypes?: StructureType[] | null;
  /** An SEM theme that needs to be passed through to other services */
  theme?: string | null;
  /** Filter results by the type of traveler. */
  travelerType?: TravelerType[] | null;
  /** Filter results by VIP only properties */
  vipOnly?: boolean | null;
}
/** Represents a range of prices for filtering properties. Follows currency rules of the user's point of sale */
export interface PriceRangeInput {
  /** The maximum price, e.g. 500.00 */
  max?: number | null;
  /** The minimum price, e.g. 50.00 */
  min?: number | null;
}
/** Represents a range of review scores for filtering properties */
export interface ReviewScoreRangeInput {
  /** The maximum review score, e.g. 5.0 */
  max?: number | null;
  /** The minimum review score, e.g. 1.0 */
  min?: number | null;
}

export interface StarRangeInput {
  max?: number | null;

  min?: number | null;
}
/** Container of all the marketing data */
export interface PropertyMarketingInfoInput {
  /** Meta affcid channel code */
  affcid?: string | null;
  /** Meta afflid channel code */
  afflid?: string | null;
  /** Meta afmcid channel code */
  afmcid?: string | null;
  /** Meta brandcid channel code */
  brandcid?: string | null;
  /** Meta emlcid channel code */
  emlcid?: string | null;
  /** Meta emldtl channel code */
  emldtl?: string | null;
  /** Meta gclid channel code */
  gclid?: string | null;
  /** Meta icmcid channel code */
  icmcid?: string | null;
  /** Meta icmdtl channel code */
  icmdtl?: string | null;
  /** Meta k_user_id channel code */
  k_user_id?: string | null;
  /** Meta kword channel code */
  kword?: string | null;
  /** Meta lnkloc channel code */
  lnkloc?: string | null;
  /** A consolidated list of marketing channels in key/value pairs.Example: [{"key": "mctc", "value": "2"}, {"key": "icmdtl", "value": "some values"}] */
  marketingChannels?: PropertyMarketingTagInput[] | null;
  /** A consolidated list of marketing prices in key/value pairs.Example: [{"key": "exp_dp", "value": "100"}, {"key": "exp_tx", "value": "10"}] */
  marketingPrices?: PropertyMarketingTagInput[] | null;
  /** Marketing Channel Type Code: Indicates traffic type, i.e. 5 for Trivago */
  mctc?: number | null;
  /** Meta mdpcid channel code */
  mdpcid?: string | null;
  /** Meta mdpdtl channel code */
  mdpdtl?: string | null;
  /** Meta olacid channel code */
  olacid?: string | null;
  /** Meta oladtl channel code */
  oladtl?: string | null;
  /** Meta semcid channel code */
  semcid?: string | null;
  /** Meta semdtl channel code */
  semdtl?: string | null;
  /** Meta seocid channel code */
  seocid?: string | null;
}
/** An object with simple key/value combination for a marketing channel or price.Example: {"key": "mctc", "value": "3"} */
export interface PropertyMarketingTagInput {
  key: string;

  value: string;
}
/** A single hotel room configuration */
export interface RoomInput {
  /** The number of adult in the room */
  adults: number;
  /** The number of children in the room */
  children?: ChildInput[] | null;
}
/** A guest over the age of 2 */
export interface ChildInput {
  /** The child's age in years */
  age: number;
}
/** @Deprecated - Additional request context for making a proxy call to BFF to get data. DO NOT USE if you aren't calling from the ShoppingPWA client. */
export interface BffRequestContextInput {
  /** Additional logging headers passed to BFF */
  additionalHeaders?: AdditionalHeaderInput[] | null;
  /** Query to pass on to BFF */
  queryParams?: string | null;
}

export interface AdditionalHeaderInput {
  name: string;

  value: string;
}
/** Minimum set of data used to retrieve details about a property product */
export interface PropertyNaturalKeyInput {
  checkIn: DateInput;

  checkOut: DateInput;

  id: string;

  inventoryType: InventoryType;

  noCreditCard?: boolean | null;

  ratePlanId: string;

  roomTypeId: string;

  rooms: PropertyRoomInput[];

  shoppingPath?: ShoppingPathType | null;
}
/** Indicates how many rooms will be occupied and by whom */
export interface PropertyRoomInput {
  childAges: number[];

  numberOfAdults: number;
}
/** [Optional] Review results filters */
export interface PropertyReviewFiltersInput {
  /** Filter review results by category */
  category?: PropertyReviewCategory | null;
  /** Include or disclude reviews that only have ratings */
  includeRatingsOnlyReviews?: boolean | null;
  /** Get reviews immediately when true (without 90 days syndication) */
  includeRecentReviews?: boolean | null;
  /** Filter reviews by specified languages by receiving lang code e.g. 'en' */
  language?: string | null;
  /** Filter review results by reviewers' locale. Example: ko_KR returns reviews made by users on Korea POSa */
  locale?: Locale | null;
  /** Filter review results by a list of review ratings */
  ratings?: number[] | null;
  /** Filter review results by review type: POSITIVE or CRITICAL */
  reviewType?: PropertyReviewType | null;
  /** Filter review results by room type */
  roomTypeId?: number | null;
  /** Filter review results by user provided keyword */
  searchTerm?: string | null;
  /** Sort reviews by Recency, high-to-low rating and low-to-high rating */
  sortRating?: string[] | null;
  /** Filter review results by travel companions */
  travelCompanion?: string[] | null;
  /** Filter reviews by tripReason and travelerCompanion depending on this list */
  travelerType?: string[] | null;
  /** Filter review results by trip reasons */
  tripReason?: string[] | null;
}
/** PWA ONLY: Input that is sent directly from the URL value. These inputs can not be parsed on a server render of the PWA and must be converted in the spinner */
export interface LegacyPropertySearchCriteriaInput {
  /** Maps to PropertyFilterAmenity */
  amenities?: string[] | null;
  /** Maps to ReviewScoreRange */
  guestRating?: string | null;
  /** Maps to PaymentType enum to account for legacy URL values */
  paymentType?: string[] | null;
  /** List of the price buckets to use. Starts from 0 index e.g. `[0,1,2]` */
  priceBuckets?: number[] | null;
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: PrivacyTrackingState | null;
  /** Maps to PropertySort */
  sort?: string | null;
  /** Maps to starList */
  stars?: string | null;
  /** Maps to StructureType */
  structureTypes?: string[] | null;
}
/** Property shop options; If this field is not supplied, a server default will be chosen */
export interface PropertyShopOptionsInput {
  /** Ads related property search option */
  listings?: Listings | null;
  /** Points related property search option */
  points?: Points | null;
}
/** User Intent corresponding to this Search */
export interface SearchIntentInput {
  /** list of interests coming from Customer Spinner */
  interests?: InterestInput[] | null;
  /** SEM param, fetch from URL */
  semDtl?: string | null;
  /** SEM param, fetch from URL */
  semdtl?: string | null;
  /** TEMP Theme param, fetch from URL. Remove after SEM migration is complete */
  theme?: string | null;
  /** TEMP intent param, fetch from URL. Support BFF while migration to BEX API */
  userIntent?: string | null;
}
/** Provides the interest of a Customer for a particular search */
export interface InterestInput {
  /** SEM id of interest */
  desmetId?: string | null;
  /** Name of interest */
  name?: string | null;
}
/** The shopping context used for all search paths, contains the search contexts for the different shopping paths */
export interface ShoppingContextInput {
  multiItem?: MultiItemContextInput | null;
}
/** The multi-item context used for package searches, contains information needed for package searches and retrieving package sessions */
export interface MultiItemContextInput {
  /** The multi-item session id used to retrieve the customers package search criteria and selected products */
  id: string;
  /** The package type for this search */
  packageType: PackageType;
}
/** Question And Answer Search filters */
export interface ProductQuestionFiltersInput {
  /** Filter Questions and Answers on the basis of this keyword */
  searchTerm?: string | null;
}

export interface CarDetailContextInput {
  carOfferToken: string;
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: string | null;

  rewardPointsSelection?: RewardsPointSelectionEnum | null;

  selectedAccessories?: string[] | null;
}

export interface ExtendedCarSearchCriteriaInput {
  appliedFilters?: AppliedFilterModelInput[] | null;
  /** temporary fields until gia service is not integrated. Will be removed later on */
  isDropOffAirport?: boolean | null;
  /** temporary field until gia service is not integrated. Will be removed later on */
  isPickUpAirport?: boolean | null;

  sort?: CarsSortOption | null;
}

export interface AppliedFilterModelInput {
  filterOptions: string[];

  raw: string;
}
/** The core criteria needed for a car search */
export interface PrimaryCarCriteriaInput {
  dropOffDateTime: DateTimeInput;

  dropOffLocation?: CarRentalLocationInput | null;

  pickUpDateTime: DateTimeInput;

  pickUpLocation: CarRentalLocationInput;
}
/** A common date time */
export interface DateTimeInput {
  /** The day of the month of the date */
  day: number;
  /** The hour of the datetime */
  hour: number;
  /** The minute of the hour */
  minute: number;
  /** The numeric month of the date */
  month: number;
  /** The second of the minute */
  second: number;
  /** The four-digit year of the date */
  year: number;
}
/** Provides the car rental location information */
export interface CarRentalLocationInput {
  airportCode?: string | null;

  coordinates?: CoordinatesInput | null;

  regionId?: string | null;

  searchTerm?: string | null;
}
/** Input argument for Request Context */
export interface ClientRequestInput {
  /** Headers of HTTP Request */
  headers: HttpHeaderInput[];
  /** Remote address of HTTP Request */
  remoteAddress: string;
  /** URL of HTTP Request */
  url: string;
}

export interface HttpHeaderInput {
  name: string;

  values: string[];
}
/** A location can be represented by a region id or an airport code. */
export interface InsightsLocationInput {
  /** Three letter IATA code associated with am airport near the location */
  airportCode?: string | null;
  /** Gaia region id of the location */
  regionId?: string | null;
}
/** Minimum set of data used to retrieve details about a flight product */
export interface FlightNaturalKeyInput {
  offerToken: string;

  passengers: PassengerBreakdownInput;

  productTokens: string[];
}
/** Indicates the kind of passengers (number and type) to search a flight for */
export interface PassengerBreakdownInput {
  childAges: number[];

  infantInSeat: boolean;

  numberOfAdults: number;

  numberOfSeniors: number;
}
/** Context for flights search */
export interface FlightsSearchContextInput {
  /** Represent the continuation identifier for spinner to deduce which all journeys have been selected. Null value represents the request is for first journey. */
  journeysContinuationId?: string | null;
  /** Trip type in search */
  tripType: FlightsTripType;
}
/** The input object for flights search */
export interface FlightsJourneyCriteriaInput {
  /** Departure departureDate of the flight */
  departureDate: DateInput;
  /** Three letter code of the destination airport */
  destination: string;
  /** Cabin class preference #DEPRECATION WARNING: Please Use cabinClass in FlightsSearchPreferences */
  flightsCabinClass?: FlightsCabinClass | null;
  /** Three letter code of the origin airport */
  origin: string;
}
/** Represents an element of the list which the client needs to send back to the server as part of the request. This will be part of each FilterItem so client need not apply any logic on filter selection but simply addd this to the next request */
export interface FlightsSearchFilterValuesInput {
  /** Represents the value associated with arrival airport filter */
  arrivalAirportCodeFilterValue?: FlightsAirportCodeFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Arrival Time filter. */
  arrivalTimeFilterValue?: FlightsTimeBasedFilterValueInput | null;
  /** Represents the value associated with departure airport filter */
  departureAirportCodeFilterValue?: FlightsAirportCodeFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Departure Time filter. */
  departureTimeFilterValue?: FlightsTimeBasedFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Duration filter. */
  durationFilterValue?: FlightsDurationBasedFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Number of stops filter. */
  numOfStopFilterValue?: FlightsStopBasedFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Preferred Airline filter. */
  preferredAirlineFilterValue?: FlightsPreferredAirlineFilterValueInput | null;
}
/** Represents the value associated with airport filter */
export interface FlightsAirportCodeFilterValueInput {
  airportCode: string;
}
/** Represents the value associated with any time based filter, like DepartureTime or ArrivalTime based filter */
export interface FlightsTimeBasedFilterValueInput {
  timeOfDay: FlightsTimeOfDay;
}
/** Represents the value associated with duration based filter */
export interface FlightsDurationBasedFilterValueInput {
  maxDuration: number;
}
/** Represents the value associated with number of stops based filter */
export interface FlightsStopBasedFilterValueInput {
  stopInfo: FlightsStopInfoInput;
}
/** Represents the stop related info for each number of stops based filter value. Combination of the number of stops and an operation.Ex. 2+ would be represented by {2,MORE_THAN} , 2 by {2,EQUAL} and <2 by {2,LESS_THAN} */
export interface FlightsStopInfoInput {
  numberOfStops: number;

  stopFilterOperation: FlightsStopFilterOperation;
}
/** Represents the value associated with preferred airline filter */
export interface FlightsPreferredAirlineFilterValueInput {
  carrierCode: string;
}
/** Preferences for flights search */
export interface FlightsSearchPreferencesInput {
  /** Represents advanced filters like non-stop, refundable */
  advancedFilters?: FlightsAdvancedFilterType[] | null;
  /** Airline preference */
  airline?: string | null;
  /** Cabin class preference */
  cabinClass: FlightsCabinClass;
}
/** Represents the combination of SortType and SortOrder ex. Price Increasing */
export interface FlightsSortOptionTypeInput {
  sortOrder: FlightsSortOrder;

  sortType: FlightsSortType;
}
/** Traveler details for flights search */
export interface FlightsTravelerDetailsInput {
  /** Age for each traveler */
  ages?: number[] | null;
  /** Traveler count */
  count: number;
  /** Traveler type */
  travelerType: FlightsTravelerType;
}

export interface PoiMapCoordinateInput {
  /** If present pins will be filtered out based on these categories */
  categories?: PoiMapItemCategory[] | null;
  /** Center coordinates to generate the map around it */
  centerCoordinates: CoordinatesInput;
  /** If present we will try to search POI based on end date */
  endDate?: string | null;
  /** If present we will try to search POI based on start date */
  startDate?: string | null;
  /** User pins with correct styling will be given back. Also the distance will be based on the first coordinate in the list */
  userCoordinates?: UserCoordinatesInput[] | null;
  /** If present this radius will be used to filter out pins */
  zoomRadius?: DistanceInput | null;
}

export interface UserCoordinatesInput {
  coordinates: CoordinatesInput;

  type: UserCoordinateType;
}
/** Measurable distance with units */
export interface DistanceInput {
  unit: DistanceUnit;

  value: number;
}

export interface FilterInput {
  displayNeighborhood?: boolean | null;

  filterLinksByIndexation?: boolean | null;

  showContinent?: boolean | null;

  showCurrentPageLink?: boolean | null;

  showCurrentPageSuffix?: boolean | null;

  showDropDown?: boolean | null;

  showLOBLink?: boolean | null;
}

export interface DestinationImageDimensionsInput {
  height: number;

  width: number;
}

export interface UserLocationInput {
  userCountryCode?: string | null;

  userLatitude: BigDecimal;

  userLongitude: BigDecimal;
}
/** A range of dates, from a starting date to an ending date */
export interface DateRangeInput {
  /** The terminal date in this range */
  end: DateInput;
  /** The starting date in this range */
  start: DateInput;
}

export interface AddInsuranceRequestInput {
  insuranceSearchId: string;

  offerTypeId: number;
}

export interface InsuranceTripMutationRequestInput {
  action: InsuranceMutationType;

  insuranceSearchId?: string | null;

  offerTypeId?: number | null;
}

export interface RemoveInsuranceRequestInput {
  insuranceSearchId: string;

  offerTypeId?: number | null;
}

export interface BookingInput {
  cars?: BookingCarInput[] | null;
  /** Email required for booking information to be sent to */
  email: string;
  /** List of ways to pay for the booking. */
  paymentMethods: PaymentMethodInput[];

  properties?: BookingPropertyInput[] | null;
  /** Total price of the booking */
  totalPrice?: MoneyInput | null;
  /** Unique identifier of the collection of products / trip */
  tripId: Uuid;
}
/** Booking information regarding a car rental product */
export interface BookingCarInput {
  contactName: PersonNameInput;

  phoneNumber: PhoneNumberInput;
  /** The unique identifier of the product sometimes referred to as componentId / entityId. Used to identify a product in the TripService. */
  reference: string;
}
/** Name of the main traveler */
export interface PersonNameInput {
  firstName: string;

  lastName: string;
}
/** Phone number with prefix number */
export interface PhoneNumberInput {
  number: string;
  /** The ISO country code (e.g. 'USA', 'GBR', etc) */
  phoneCountryId: string;
}
/** Requires at least 1 payment method to be provided. Currently only supports Credit Card and single payment. */
export interface PaymentMethodInput {
  /** Amount of money to charge for this payment method, not providing this assumes full amount */
  amountToCharge: MoneyInput;
  /** Payment token information which will be used to pay for the booking */
  paymentToken?: PaymentTokenInput | null;
}
/** Pricing information */
export interface MoneyInput {
  /** Numeric portion of the price */
  amount: number;
  /** The ISO 4217 3-letter code for this currency eg: USD EUR GBP ... */
  currency?: string | null;
}

export interface PaymentTokenInput {
  /** When provided, will store the payment method for future use */
  saveAs?: string | null;
  /** Edge Token used for the payment */
  token: string;
  /** Type of payment being processed by the edge token */
  type: PaymentTokenType;
}
/** Booking information regarding a property product */
export interface BookingPropertyInput {
  contactName: PersonNameInput;

  phoneNumber: PhoneNumberInput;

  preferences?: PropertyPreferencesInput | null;
  /** The unique identifier of the product sometimes referred to as componentId / entityId. Used to identify a product in the TripService. */
  reference: string;
  /** Indicates whether the user wants to receive a confirmation sms or not. Default type is false. */
  sendConfirmationText?: boolean | null;
}
/** Outlines the user's requests and preferences to the property */
export interface PropertyPreferencesInput {
  /** List of user's accessibility requests */
  accessibilityRequests?: string[] | null;
  /** The user's requested bed type */
  bedType?: string | null;
  /** Indicates whether the user would prefer a smoking or non smoking room */
  smoking?: boolean | null;
  /** Free text special request to be conveyed to the property */
  specialRequests?: string | null;
}
/** Describes a Property related Conversation */
export interface LodgingConversationMetadataInput {
  checkIn: DateInput;

  checkOut: DateInput;

  createdAt: Url;

  from: MessageFromInput;

  propertyId: string;

  rooms: PropertyRoomInput[];
}

export interface MessageFromInput {
  emailAddress: string;

  name: string;
}

export interface CartFlightSearchContextInput {
  /** The age of every children at the time of the flight */
  childAges: number[];
  /** Flight filters */
  filter?: CartFlightFilterInput | null;
  /** The list of infant(s) sitting on laps */
  infantsInLap: boolean[];
  /** The number of adults */
  numberOfAdults: number;
  /** List of origins and destinations flight components */
  originDestinations: CartOriginDestinationSearchInput[];
  /** The type of ticket searched */
  searchType: CartFlightSearchType;
}

export interface CartFlightFilterInput {
  /** non-stop flights only filter */
  nonStopOnly?: boolean | null;
  /** Preferred airline filter */
  preferredAirline?: string | null;
  /** Preferred class filter */
  preferredClass?: string | null;
  /** refundable flights only filter */
  refundableOnly?: boolean | null;
}

export interface CartOriginDestinationSearchInput {
  /** The departure date of the flight */
  departure: DateInput;
  /** The code (TLA) of the arrival airport */
  destinationAirportCode: string;
  /** The code (TLA) of the departure airport */
  originAirportCode: string;
}
/** Minimum set of data used to retrieve details about a property product */
export interface PropertyOfferInput {
  naturalKeys: PropertyNaturalKeyInput[];

  offerIndex: number;
}

export interface CartPropertySearchContextInput {
  /** The checking date for the property rental */
  checkIn: DateInput;
  /** The checkOut date for the property rental */
  checkOut: DateInput;
  /** The id of the region where the hotel is located - from lodging domain */
  regionId: string;
  /** The list of rooms that user searched for */
  rooms: PropertyRoomInput[];
}
/** All criteria needed for a multi-item search */
export interface MultiItemSearchContextInput {
  cars?: CarSearchCriteriaInput[] | null;

  properties?: PropertySearchCriteriaInput[] | null;
}
/** Car criteria needed to perform a car search */
export interface CarSearchCriteriaInput {
  primary: PrimaryCarCriteriaInput;

  secondary?: ShoppingSearchCriteriaInput | null;
}
/** Key/Value elements that describes the search criteria often displayed to the customer as filters */
export interface ShoppingSearchCriteriaInput {
  booleans?: BooleanValueInput[] | null;

  counts?: NumberValueInput[] | null;

  dates?: DateValueInput[] | null;

  ranges?: RangeValueInput[] | null;

  selections?: SelectedValueInput[] | null;
}
/** Type used during a product search to specify a given boolean value like the fact customer would prefer to search for direct flights only. */
export interface BooleanValueInput {
  id: string;

  value: boolean;
}
/** Type used during a product search to specify a given numeric value like the number of stars for a hotel. */
export interface NumberValueInput {
  id: string;

  value: number;
}
/** Type used during a product search to specify a given date. Usually this date would not be a core search criteria like a departure day for a flight. */
export interface DateValueInput {
  id: string;

  value: DateInput;
}
/** Type used during a product search to specify a given numeric range like the price of a hotel should be between 100 and 200 (USD). */
export interface RangeValueInput {
  id: string;

  max: number;

  min: number;
}
/** Type used during a product search to specify a given selection like the airline the customer would like to fly with. */
export interface SelectedValueInput {
  id: string;

  value: string;
}
/** Property criteria needed to perform a property search */
export interface PropertySearchCriteriaInput {
  primary: PrimaryPropertyCriteriaInput;

  secondary?: ShoppingSearchCriteriaInput | null;
}
/** The core criteria needed for a property search */
export interface PrimaryPropertyCriteriaInput {
  dateRange?: PropertyDateRangeInput | null;

  destination: DestinationInput;

  rooms: RoomInput[];
}
/** Options for the session cart being created */
export interface CartOptionsInput {
  ttl: CartTtl;
}
/** Minimum set of data used to retrieve details about an activity product */
export interface ActivityNaturalKeyInput {
  offerToken: string;

  productToken: string;
}

export interface HoldingAreaActivitySearchContextInput {
  end: DateInput;

  regionId: string;

  start: DateInput;
}
/** Minimum set of data used to retrieve details about a car product */
export interface CarNaturalKeyInput {
  offerToken: string;

  specialEquipments?: SpecialEquipment[] | null;
}
/** All criteria needed to perform a flight search */
export interface FlightSearchCriteriaInput {
  primary: PrimaryFlightCriteriaInput;

  secondary?: ShoppingSearchCriteriaInput | null;
}
/** The core criteria needed for a flight search (type and airports) */
export interface PrimaryFlightCriteriaInput {
  /** origins and destinations */
  originDestinations: OriginDestinationCriteriaInput[];
  /** flight type */
  searchType: FlightSearchType;
}
/** Indicates flight origin and destination Criteria */
export interface OriginDestinationCriteriaInput {
  departure: DateInput;

  destinationAirportCode: string;

  originAirportCode: string;
}
/** Checkout option and its value to apply on the checkoutUrl */
export interface CheckoutOptionInput {
  type: CheckoutOptionType;

  value: string;
}
/** Key/Value pairs of data required by the client for playback. (Optional) */
export interface ShortlistMetadataInput {
  key: string;

  value: string;
}

// ====================================================
// Enums
// ====================================================

/** Specifies the behavior of ALTER, which is used to run Abacus experiments on localization messages. */
export enum AlterMode {
  DEBUG = 'DEBUG',
  NONE = 'NONE',
  PREVIEW = 'PREVIEW',
  RELEASED = 'RELEASED'
}
/** Valid device types */
export enum DeviceType {
  APP_PHONE = 'APP_PHONE',
  APP_TABLET = 'APP_TABLET',
  CHAT_APP = 'CHAT_APP',
  DESKTOP = 'DESKTOP',
  MOBILE_PHONE = 'MOBILE_PHONE',
  MOBILE_TABLET = 'MOBILE_TABLET',
  VOICE_APP = 'VOICE_APP'
}

export enum AuthenticationState {
  ANONYMOUS = 'ANONYMOUS',
  AUTHENTICATED = 'AUTHENTICATED',
  IDENTIFIED = 'IDENTIFIED'
}
/** Privacy tracking user preference. We can retrieve info on if the site allows tracking from Site Info and null can also be used to represent a selection or not */
export enum PrivacyTrackingState {
  CAN_NOT_TRACK = 'CAN_NOT_TRACK',
  CAN_TRACK = 'CAN_TRACK'
}
/** Enumerated Gaia geographic region types */
export enum RegionType {
  AIRPORT = 'AIRPORT',
  CITY = 'CITY',
  CONTINENT = 'CONTINENT',
  COUNTRY = 'COUNTRY',
  HIGH_LEVEL_REGION = 'HIGH_LEVEL_REGION',
  METRO_STATION = 'METRO_STATION',
  MULTI_CITY_VICINITY = 'MULTI_CITY_VICINITY',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POINT_OF_INTEREST = 'POINT_OF_INTEREST',
  PROVINCE_STATE = 'PROVINCE_STATE',
  TRAIN_STATION = 'TRAIN_STATION',
  UNKNOWN = 'UNKNOWN'
}
/** ID used to identify a month for queries that bucket data by month */
export enum MonthId {
  APRIL = 'APRIL',
  AUGUST = 'AUGUST',
  DECEMBER = 'DECEMBER',
  FEBRUARY = 'FEBRUARY',
  JANUARY = 'JANUARY',
  JULY = 'JULY',
  JUNE = 'JUNE',
  MARCH = 'MARCH',
  MAY = 'MAY',
  NOVEMBER = 'NOVEMBER',
  OCTOBER = 'OCTOBER',
  SEPTEMBER = 'SEPTEMBER'
}
/** Search options that are not filters */
export enum ActivitySearchOptions {
  CATEGORY = 'CATEGORY',
  FILTER_NESTED_CATEGORIES = 'FILTER_NESTED_CATEGORIES',
  GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER = 'GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER',
  GIFTING_ACTIVITIES = 'GIFTING_ACTIVITIES',
  GUEST_PROMO = 'GUEST_PROMO',
  NON_CONSOLIDATED_OFFERS = 'NON_CONSOLIDATED_OFFERS',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}

export enum ActivityBadgeType {
  CAMPAIGN_DEAL = 'CAMPAIGN_DEAL',
  DEAL_ADD_ON = 'DEAL_ADD_ON',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER'
}

export enum ActivityCategory {
  ADULTS_ONLY_SHOWS = 'ADULTS_ONLY_SHOWS',
  ADVENTURES = 'ADVENTURES',
  ADVENTURE_OUTDOOR = 'ADVENTURE_OUTDOOR',
  AIRBOAT_TOURS = 'AIRBOAT_TOURS',
  AIRPLANE_RIDES = 'AIRPLANE_RIDES',
  AIRPLANE_TOURS = 'AIRPLANE_TOURS',
  AIRPORT_GROUND_TRANSPORTATION = 'AIRPORT_GROUND_TRANSPORTATION',
  AIRPORT_LOUNGES = 'AIRPORT_LOUNGES',
  AIRPORT_TO_AIRPORT_TRANSFERS = 'AIRPORT_TO_AIRPORT_TRANSFERS',
  AIR_BALLOON_HELICOPTER_TOURS = 'AIR_BALLOON_HELICOPTER_TOURS',
  AIR_HELICOPTER_BALLOON_TOURS = 'AIR_HELICOPTER_BALLOON_TOURS',
  AMUSEMENT_THEME_PARKS = 'AMUSEMENT_THEME_PARKS',
  ARCHITECTURE_TOURS = 'ARCHITECTURE_TOURS',
  ART_CLASSES = 'ART_CLASSES',
  ART_CULTURE_HISTORY_TOURS = 'ART_CULTURE_HISTORY_TOURS',
  ART_MUSIC_LITERARYTOURS = 'ART_MUSIC_LITERARYTOURS',
  ATTRACTIONS = 'ATTRACTIONS',
  ATTRACTION_TICKETS = 'ATTRACTION_TICKETS',
  BALLOON_RIDES = 'BALLOON_RIDES',
  BALLOON_TOURS = 'BALLOON_TOURS',
  BAR_PUB_TOURS = 'BAR_PUB_TOURS',
  BEER_BREWERY_TOURS = 'BEER_BREWERY_TOURS',
  BEYOND_THE_CITY = 'BEYOND_THE_CITY',
  BIKE_MOUNTAIN_BIKE_TOURS = 'BIKE_MOUNTAIN_BIKE_TOURS',
  BIKE_RENTALS = 'BIKE_RENTALS',
  BOAT_RENTAL = 'BOAT_RENTAL',
  BOAT_TOURS = 'BOAT_TOURS',
  BOAT_TOURS_CRUISES = 'BOAT_TOURS_CRUISES',
  BRUNCHC_RUISES = 'BRUNCHC_RUISES',
  BUNGEE_JUMPING_SKYDIVING = 'BUNGEE_JUMPING_SKYDIVING',
  BUS_MINIVAN_TOURS = 'BUS_MINIVAN_TOURS',
  CABARET = 'CABARET',
  CAMPAIGN_DEALS = 'CAMPAIGN_DEALS',
  CASTLE_PALACE_TOURS = 'CASTLE_PALACE_TOURS',
  CHAUFFER_SERVICES = 'CHAUFFER_SERVICES',
  CHRISTMAS = 'CHRISTMAS',
  CIRQUE = 'CIRQUE',
  CIRQUE_DU_SOLEIL = 'CIRQUE_DU_SOLEIL',
  CIRQUE_DU_SOLEILSHOWS = 'CIRQUE_DU_SOLEILSHOWS',
  CITY_AND_ATTRACTION_TRANSFERS = 'CITY_AND_ATTRACTION_TRANSFERS',
  CITY_ATTRACTION_TRANSFERS = 'CITY_ATTRACTION_TRANSFERS',
  CITY_TOURS = 'CITY_TOURS',
  CITY_TOURS_PACKAGES = 'CITY_TOURS_PACKAGES',
  CLASSES_WORKSHOPS = 'CLASSES_WORKSHOPS',
  CLUB_AND_PARTY_BUS_TOURS = 'CLUB_AND_PARTY_BUS_TOURS',
  CLUB_PARTY_BUS_TOURS = 'CLUB_PARTY_BUS_TOURS',
  COFFEE_TEA_TOURS = 'COFFEE_TEA_TOURS',
  COMEDY_SHOWS = 'COMEDY_SHOWS',
  CONCERTS_SPECIAL_EVENTS = 'CONCERTS_SPECIAL_EVENTS',
  COOKING_CLASSES = 'COOKING_CLASSES',
  CRUISES_BOAT_TOURS = 'CRUISES_BOAT_TOURS',
  CRUISES_WATER_TOURS = 'CRUISES_WATER_TOURS',
  CULTURAL_HERITAGE_EXPERIENCES = 'CULTURAL_HERITAGE_EXPERIENCES',
  CUSTOM_PRIVATE_TOURS = 'CUSTOM_PRIVATE_TOURS',
  DANCE_CLASSES = 'DANCE_CLASSES',
  DAY_OF_THE_DEAD = 'DAY_OF_THE_DEAD',
  DAY_SPAS = 'DAY_SPAS',
  DAY_TRIPS = 'DAY_TRIPS',
  DAY_TRIPS_EXCURSIONS = 'DAY_TRIPS_EXCURSIONS',
  DINING_EXPERIENCES = 'DINING_EXPERIENCES',
  DINNER_CRUISES = 'DINNER_CRUISES',
  DINNER_THEATER = 'DINNER_THEATER',
  DISNEY = 'DISNEY',
  DISNEY_PARKS = 'DISNEY_PARKS',
  DOLPHIN_WHALE_WATCHING = 'DOLPHIN_WHALE_WATCHING',
  DOSE_OF_CULTURE = 'DOSE_OF_CULTURE',
  DUCK_TOURS = 'DUCK_TOURS',
  EASTER = 'EASTER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  FASHION_SHOWS_TOURS = 'FASHION_SHOWS_TOURS',
  FISHING_CHARTERS_TOURS = 'FISHING_CHARTERS_TOURS',
  FISHING_TOURS_AND_CHARTERS = 'FISHING_TOURS_AND_CHARTERS',
  FOOD_DRINK = 'FOOD_DRINK',
  FOOD_DRINK_NIGHTLIFE = 'FOOD_DRINK_NIGHTLIFE',
  FOOD_TOURS = 'FOOD_TOURS',
  FUN_FOR_FOODIES = 'FUN_FOR_FOODIES',
  FUN_ON_THE_WATER = 'FUN_ON_THE_WATER',
  GALLERIES_MUSEUMS = 'GALLERIES_MUSEUMS',
  GAMES_SHOWS_SPECIAL_EVENTS = 'GAMES_SHOWS_SPECIAL_EVENTS',
  GETTING_AROUND = 'GETTING_AROUND',
  GOLF_TEE_TIMES = 'GOLF_TEE_TIMES',
  GOLF_TOURS_TEE_TIMES = 'GOLF_TOURS_TEE_TIMES',
  HALLOWEEN = 'HALLOWEEN',
  HAMMAMS_TURKISH_BATHS = 'HAMMAMS_TURKISH_BATHS',
  HELICOPTER_RIDES = 'HELICOPTER_RIDES',
  HELICOPTER_TOURS = 'HELICOPTER_TOURS',
  HIGH_SPEED_DRIVING = 'HIGH_SPEED_DRIVING',
  HIGH_SPEED_RIDES = 'HIGH_SPEED_RIDES',
  HIKING_CAMPING = 'HIKING_CAMPING',
  HISTORICAL_TOURS = 'HISTORICAL_TOURS',
  HISTORY_CULTURE = 'HISTORY_CULTURE',
  HOLIDAY_SEASONAL_TOURS = 'HOLIDAY_SEASONAL_TOURS',
  HONEYMOON_PACKAGE = 'HONEYMOON_PACKAGE',
  HONEYMOON_PACKAGES = 'HONEYMOON_PACKAGES',
  HOP_ON_HOP_OFF = 'HOP_ON_HOP_OFF',
  HOP_ON_HOP_OFF_TOURS = 'HOP_ON_HOP_OFF_TOURS',
  HORSE_CARRIAGE_RIDES = 'HORSE_CARRIAGE_RIDES',
  HOT_SPRINGS_THERMAL_SPAS = 'HOT_SPRINGS_THERMAL_SPAS',
  INTERESTS = 'INTERESTS',
  KAYAKING_CANOEING = 'KAYAKING_CANOEING',
  LATEST_GREATEST = 'LATEST_GREATEST',
  LIFT_TICKETS = 'LIFT_TICKETS',
  LIKELY_TO_SELL_OUT = 'LIKELY_TO_SELL_OUT',
  LITERARY_ART_MUSIC_TOURS = 'LITERARY_ART_MUSIC_TOURS',
  LOCAL_EXPERT_PICKS = 'LOCAL_EXPERT_PICKS',
  LUNCH_CRUISES = 'LUNCH_CRUISES',
  MOTORCYCLE_SCOOTER_TOURS = 'MOTORCYCLE_SCOOTER_TOURS',
  MOVIE_TV_TOURS = 'MOVIE_TV_TOURS',
  MULTIDAY_CRUISES = 'MULTIDAY_CRUISES',
  MULTI_DAY_EXTENDED_TOURS = 'MULTI_DAY_EXTENDED_TOURS',
  MUSEUM_TICKETS = 'MUSEUM_TICKETS',
  MUSEUM_TICKETS_PASSES = 'MUSEUM_TICKETS_PASSES',
  MUST_SEE_SIGHTS = 'MUST_SEE_SIGHTS',
  NA = 'NA',
  NATIONAL_HOLIDAYS = 'NATIONAL_HOLIDAYS',
  NEW = 'NEW',
  NEWY_EARS = 'NEWY_EARS',
  NIGHTLIFE = 'NIGHTLIFE',
  NIGHTLIFE_PASSES = 'NIGHTLIFE_PASSES',
  NIGHT_CRUISES = 'NIGHT_CRUISES',
  NIGHT_TOURS = 'NIGHT_TOURS',
  ONSENS = 'ONSENS',
  OTHER_ANIMALS_ACTIVITIES = 'OTHER_ANIMALS_ACTIVITIES',
  OTHER_ANIMAL_ACTIVITIES = 'OTHER_ANIMAL_ACTIVITIES',
  OTHER_CLASSES = 'OTHER_CLASSES',
  OTHER_OUTDOOR_ACTIVITIES = 'OTHER_OUTDOOR_ACTIVITIES',
  OTHER_SEASONAL_EVENTS = 'OTHER_SEASONAL_EVENTS',
  OTHER_TOURS = 'OTHER_TOURS',
  OTHER_TRANSFERS = 'OTHER_TRANSFERS',
  OTHER_TRANSPORTATION = 'OTHER_TRANSPORTATION',
  OTHER_WATER_ACTIVITIES = 'OTHER_WATER_ACTIVITIES',
  PHOTOGRAPHY_TOURS = 'PHOTOGRAPHY_TOURS',
  PORT_TRANSFERS = 'PORT_TRANSFERS',
  PRIVATE_CUSTOM_TOURS = 'PRIVATE_CUSTOM_TOURS',
  PRIVATE_DAY_TRIPS = 'PRIVATE_DAY_TRIPS',
  PRIVATE_TOURS = 'PRIVATE_TOURS',
  PRIVATE_TRANSFERS = 'PRIVATE_TRANSFERS',
  PURE_ROMANCE = 'PURE_ROMANCE',
  RELIGIOUS_SPIRITUAL_TOURS = 'RELIGIOUS_SPIRITUAL_TOURS',
  RIVER_HARBOUR_CRUISES = 'RIVER_HARBOUR_CRUISES',
  ROMAN_STAYCATION = 'ROMAN_STAYCATION',
  SAFARIS = 'SAFARIS',
  SAILING_TRIPS = 'SAILING_TRIPS',
  SCOOTER_RENTALS = 'SCOOTER_RENTALS',
  SEGWAY_TOURS = 'SEGWAY_TOURS',
  SHARED_TRANSFERS = 'SHARED_TRANSFERS',
  SHARK_DIVING = 'SHARK_DIVING',
  SHOPPING_FASHION = 'SHOPPING_FASHION',
  SHOPPING_PASSES_OFFERS = 'SHOPPING_PASSES_OFFERS',
  SHOPPING_TOURS = 'SHOPPING_TOURS',
  SHORE_EXCURIONS = 'SHORE_EXCURIONS',
  SHOWS_CONCERTS = 'SHOWS_CONCERTS',
  SHOW_SPORT_TICKETS = 'SHOW_SPORT_TICKETS',
  SIGHTSEEING_ATTRACTION_PASSES = 'SIGHTSEEING_ATTRACTION_PASSES',
  SIGHTSEEING_CITY_PASSES = 'SIGHTSEEING_CITY_PASSES',
  SIGHTSEEING_PASSES = 'SIGHTSEEING_PASSES',
  SKIING_RENTALS = 'SKIING_RENTALS',
  SKIP_THE_LINE_TOURS = 'SKIP_THE_LINE_TOURS',
  SNORKELING_SCUBA_DIVING = 'SNORKELING_SCUBA_DIVING',
  SNOWBOARDING_RENTALS = 'SNOWBOARDING_RENTALS',
  SNOWMOBILE_TOURS = 'SNOWMOBILE_TOURS',
  SNOWSHOEING = 'SNOWSHOEING',
  SPA = 'SPA',
  SPA_WELLNESS = 'SPA_WELLNESS',
  SPEED_BOATS_JET_SKIS = 'SPEED_BOATS_JET_SKIS',
  SPORTING_EVENTS_PACKAGES = 'SPORTING_EVENTS_PACKAGES',
  SPORTS_PACKAGES = 'SPORTS_PACKAGES',
  STAY_ACTIVE = 'STAY_ACTIVE',
  SUBMARINE_TOURS = 'SUBMARINE_TOURS',
  SUNSET_CRUISES = 'SUNSET_CRUISES',
  SUPERNATURAL_TOURS = 'SUPERNATURAL_TOURS',
  SUSTAINABLE_TOURS = 'SUSTAINABLE_TOURS',
  SWIM_WITH_DOLPHINS = 'SWIM_WITH_DOLPHINS',
  THEATER_SHOWS_MUSICALS = 'THEATER_SHOWS_MUSICALS',
  THEME_PARKS = 'THEME_PARKS',
  THEME_PARK_TICKETS_TOURS = 'THEME_PARK_TICKETS_TOURS',
  THE_GREAT_OUTDOORS = 'THE_GREAT_OUTDOORS',
  THRILL_SEEKER = 'THRILL_SEEKER',
  TICKETS = 'TICKETS',
  TOURS_ACTIVITIES = 'TOURS_ACTIVITIES',
  TOURS_SIGHTSEEING = 'TOURS_SIGHTSEEING',
  TRANSPORTATION_SERVICES = 'TRANSPORTATION_SERVICES',
  TREAT_YOURSELF = 'TREAT_YOURSELF',
  TUBING = 'TUBING',
  UNIVERSAL_THEME_PARKS = 'UNIVERSAL_THEME_PARKS',
  VALENTINES_DAY = 'VALENTINES_DAY',
  WALKING_BIKE_TOURS = 'WALKING_BIKE_TOURS',
  WALKING_TOURS = 'WALKING_TOURS',
  WATERSKIING_WAKEBOARDING = 'WATERSKIING_WAKEBOARDING',
  WATER_ACTIVITIES = 'WATER_ACTIVITIES',
  WATER_PARKS = 'WATER_PARKS',
  WEDDING_CEREMONIES = 'WEDDING_CEREMONIES',
  WEDDING_HONEYMOON = 'WEDDING_HONEYMOON',
  WEDDING_PACKAGES = 'WEDDING_PACKAGES',
  WEDDING_SHONEYMOONS = 'WEDDING_SHONEYMOONS',
  WHAT_TO_DO_WITH_GROUPS = 'WHAT_TO_DO_WITH_GROUPS',
  WHAT_TO_DO_WITH_KIDS = 'WHAT_TO_DO_WITH_KIDS',
  WHITE_WATER_RAFTING = 'WHITE_WATER_RAFTING',
  WILDLIFE_NATURE = 'WILDLIFE_NATURE',
  WINE_TASTING_WINERY_TOURS = 'WINE_TASTING_WINERY_TOURS',
  WINTER_ACTIVITIES = 'WINTER_ACTIVITIES',
  YOGA_CLASS = 'YOGA_CLASS',
  YOGA_CLASSES = 'YOGA_CLASSES',
  ZOO_TICKETS = 'ZOO_TICKETS',
  ZOO_TICKETS_PASSES = 'ZOO_TICKETS_PASSES'
}

export enum ChronoUnit {
  CENTURIES = 'CENTURIES',
  DAYS = 'DAYS',
  DECADES = 'DECADES',
  ERAS = 'ERAS',
  FOREVER = 'FOREVER',
  HALFDAYS = 'HALFDAYS',
  HOURS = 'HOURS',
  MICROS = 'MICROS',
  MILLENNIA = 'MILLENNIA',
  MILLIS = 'MILLIS',
  MINUTES = 'MINUTES',
  MONTHS = 'MONTHS',
  NANOS = 'NANOS',
  SECONDS = 'SECONDS',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS'
}

export enum ActivityCancellationType {
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  NO_CANCELLATION = 'NO_CANCELLATION'
}

export enum ActivityDiscountType {
  AIR_ATTACH_MIP = 'AIR_ATTACH_MIP',
  AIR_HOTEL_ATTACH_MIP = 'AIR_HOTEL_ATTACH_MIP',
  CAMPAIGN_DEAL = 'CAMPAIGN_DEAL',
  FREE_ACTIVITY = 'FREE_ACTIVITY',
  GUEST = 'GUEST',
  HOTEL_ATTACH_MIP = 'HOTEL_ATTACH_MIP',
  MOD = 'MOD',
  STRIKE_OUT = 'STRIKE_OUT'
}

export enum ActivityRedemptionType {
  PRINT = 'PRINT',
  VOUCHER_LESS = 'VOUCHER_LESS'
}
/** Activity Price types */
export enum ActivityPriceType {
  GROUP = 'GROUP',
  NORMAL = 'NORMAL',
  VOLUME_BASED = 'VOLUME_BASED'
}

export enum ActivityOfferUdsToken {
  SELECTED = 'SELECTED',
  UNSELECTED = 'UNSELECTED'
}
/** Activity banner type */
export enum ActivityBannerType {
  ALERT = 'ALERT',
  INFO = 'INFO',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}
/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum ActivityMessageType {
  ADDON = 'ADDON',
  EARN_2X_REWARD_POINTS = 'EARN_2X_REWARD_POINTS',
  GIFTING_LX_BANNER = 'GIFTING_LX_BANNER',
  LOGIN = 'LOGIN',
  SOURCED_CAMPAIGN = 'SOURCED_CAMPAIGN',
  SUMMER_CAMPAIGN_PRIMARY = 'SUMMER_CAMPAIGN_PRIMARY',
  SUMMER_CAMPAIGN_SECONDARY = 'SUMMER_CAMPAIGN_SECONDARY'
}

export enum ActivityReviewSort {
  HIGHEST_TO_LOWEST_RATED = 'HIGHEST_TO_LOWEST_RATED',
  LOWEST_TO_HIGHEST_RATED = 'LOWEST_TO_HIGHEST_RATED',
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST'
}
/** Activity sort types */
export enum ActivitySort {
  CAMPAIGN_DEALS = 'CAMPAIGN_DEALS',
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  RECOMMENDED = 'RECOMMENDED'
}

export enum ActivityGroupType {
  ACTIVITY_LIST = 'ACTIVITY_LIST',
  ACTIVITY_MESSAGE = 'ACTIVITY_MESSAGE',
  AVAILABLE_TODAY = 'AVAILABLE_TODAY',
  CATEGORY = 'CATEGORY',
  FILTERED_ACTIVITIES = 'FILTERED_ACTIVITIES',
  INTERESTS = 'INTERESTS',
  KEYWORD_SEARCH = 'KEYWORD_SEARCH',
  MORE_ACTIVITIES = 'MORE_ACTIVITIES',
  NEIGHBOURHOOD = 'NEIGHBOURHOOD',
  PINNED_ACTIVITY = 'PINNED_ACTIVITY',
  POI = 'POI',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  SLIM_CATEGORY = 'SLIM_CATEGORY',
  SUB_CATEGORIES = 'SUB_CATEGORIES',
  SUB_CATEGORY = 'SUB_CATEGORY',
  TOP_ACTIVITIES = 'TOP_ACTIVITIES',
  XSELL_RECOMMENDATIONS = 'XSELL_RECOMMENDATIONS'
}

export enum ActivityMapGroupType {
  POI = 'POI'
}
/** Activity Pill Theme */
export enum ActivityPillTheme {
  CATEGORY_FILTER = 'CATEGORY_FILTER',
  FREE_TEXT_SEARCH = 'FREE_TEXT_SEARCH',
  PRICE = 'PRICE',
  SEE_ALL = 'SEE_ALL'
}

export enum ActivityCategoryType {
  ACTIVITIES = 'ACTIVITIES',
  CATEGORIES = 'CATEGORIES',
  DEALS_PROMOTIONS = 'DEALS_PROMOTIONS',
  NA = 'NA',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  TOURS = 'TOURS',
  TRANSPORTATION = 'TRANSPORTATION'
}

export enum ActivityUdsToken {
  MULTI_SELECT_LIST = 'MULTI_SELECT_LIST',
  SINGLE_SELECT = 'SINGLE_SELECT',
  TEXT = 'TEXT'
}

export enum InsurancePhrasePartStyle {
  COLOR_GREEN = 'COLOR_GREEN',
  COLOR_RED = 'COLOR_RED',
  EMPHASIS = 'EMPHASIS',
  IMPORTANT = 'IMPORTANT',
  STANDARD = 'STANDARD'
}

export enum InsuranceListType {
  ICON = 'ICON',
  NUMBERED = 'NUMBERED'
}

export enum PropertyFilterAccessibility {
  ACCESSIBLE_BATHROOM = 'ACCESSIBLE_BATHROOM',
  IN_ROOM_ACCESSIBLE = 'IN_ROOM_ACCESSIBLE',
  ROLL_IN_SHOWER = 'ROLL_IN_SHOWER'
}

export enum AgencyBusinessModel {
  EXPEDIA_COLLECT = 'EXPEDIA_COLLECT',
  HOTEL_COLLECT = 'HOTEL_COLLECT'
}

export enum PropertyFilterAmenity {
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  CASINO = 'CASINO',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_PARKING = 'FREE_PARKING',
  HOT_SPRING = 'HOT_SPRING',
  HOT_TUB = 'HOT_TUB',
  KITCHEN_KITCHEN = 'KITCHEN_KITCHEN',
  KITCHEN_KITCHENETTE = 'KITCHEN_KITCHENETTE',
  OCEAN_VIEW = 'OCEAN_VIEW',
  PETS = 'PETS',
  POOL = 'POOL',
  SPA_ON_SITE = 'SPA_ON_SITE',
  WASHER_DRYER = 'WASHER_DRYER',
  WATER_PARK = 'WATER_PARK',
  WIFI = 'WIFI'
}

export enum CommissionTier {
  BASIC = 'BASIC',
  BASIC_PLUS = 'BASIC_PLUS',
  PREMIUM = 'PREMIUM',
  PREMIUM_PLUS = 'PREMIUM_PLUS'
}

export enum DealType {
  AARP = 'AARP'
}

export enum MealPlanFilterAmenity {
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FULL_BOARD = 'FULL_BOARD',
  HALF_BOARD = 'HALF_BOARD'
}

export enum PaymentType {
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  PAY_LATER = 'PAY_LATER',
  PAY_WITHOUT_CREDITCARD = 'PAY_WITHOUT_CREDITCARD'
}

export enum PropertyStyle {
  HOMES = 'HOMES',
  HOTELS = 'HOTELS',
  LUXURY = 'LUXURY',
  OUTDOOR = 'OUTDOOR',
  UNIQUE = 'UNIQUE'
}

export enum StructureType {
  AGRITOURISM = 'AGRITOURISM',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  APARTMENT = 'APARTMENT',
  APART_HOTEL = 'APART_HOTEL',
  BED_AND_BREAKFAST = 'BED_AND_BREAKFAST',
  CABIN = 'CABIN',
  CARAVAN_PARK = 'CARAVAN_PARK',
  CASTLE = 'CASTLE',
  CHALET = 'CHALET',
  CONDO = 'CONDO',
  CONDO_RESORT = 'CONDO_RESORT',
  COTTAGE = 'COTTAGE',
  COUNTRY_HOUSE = 'COUNTRY_HOUSE',
  CRUISE = 'CRUISE',
  ECO_HOTEL = 'ECO_HOTEL',
  GUEST_HOUSE = 'GUEST_HOUSE',
  HOLIDAY_PARK = 'HOLIDAY_PARK',
  HOSTAL = 'HOSTAL',
  HOSTEL = 'HOSTEL',
  HOTEL = 'HOTEL',
  HOTEL_RESORT = 'HOTEL_RESORT',
  HOUSE_BOAT = 'HOUSE_BOAT',
  INN = 'INN',
  LODGE = 'LODGE',
  LONGHOUSE = 'LONGHOUSE',
  MOTEL = 'MOTEL',
  OVERWATER = 'OVERWATER',
  PALACE = 'PALACE',
  PENSION = 'PENSION',
  POUSADA_BRAZIL = 'POUSADA_BRAZIL',
  POUSADA_PORTUGAL = 'POUSADA_PORTUGAL',
  RANCH = 'RANCH',
  RESIDENCE = 'RESIDENCE',
  RIAD = 'RIAD',
  RYOKAN = 'RYOKAN',
  SAFARI = 'SAFARI',
  SERVICED_APARTMENT = 'SERVICED_APARTMENT',
  TOWNHOUSE = 'TOWNHOUSE',
  TRADITIONAL_BUILDING = 'TRADITIONAL_BUILDING',
  TREE_HOUSE = 'TREE_HOUSE',
  UNKNOWN = 'UNKNOWN',
  VACATION_HOME = 'VACATION_HOME',
  VILLA = 'VILLA',
  VIP = 'VIP'
}

export enum TravelerType {
  BUSINESS = 'BUSINESS',
  FAMILY = 'FAMILY'
}
/** Search options that are not filters. Previously these were a large set of boolean flags in ExpWeb called `searchOptions` */
export enum PropertySearchOptions {
  ADS_ONLY = 'ADS_ONLY',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}
/** Hotel sort types */
export enum PropertySort {
  AARP_MEMBER_DISCOUNT = 'AARP_MEMBER_DISCOUNT',
  BEST_DEAL = 'BEST_DEAL',
  DISTANCE = 'DISTANCE',
  MEMBER_PRICING = 'MEMBER_PRICING',
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  PRICE_RELEVANT = 'PRICE_RELEVANT',
  PROPERTY_CLASS = 'PROPERTY_CLASS',
  PROPERTY_NAME = 'PROPERTY_NAME',
  RECOMMENDED = 'RECOMMENDED',
  REVIEW = 'REVIEW',
  VACATION_RENTAL = 'VACATION_RENTAL'
}

export enum PropertyPaymentType {
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_NOW = 'PAY_NOW'
}
/** Options that are not filters. Refer @code { SearchOptions } */
export enum PropertyInfoOptions {
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}
/** Indicate the inventory type of a given offer */
export enum InventoryType {
  AICTRAVELGROUP = 'AICTRAVELGROUP',
  AMOMA = 'AMOMA',
  ANA = 'ANA',
  BESTBUYHOTEL = 'BESTBUYHOTEL',
  BONOTEL = 'BONOTEL',
  CNTRAVEL = 'CNTRAVEL',
  CTRIP = 'CTRIP',
  DESPEGAR = 'DESPEGAR',
  DIDATRAVEL = 'DIDATRAVEL',
  DIRECT_AGENCY = 'DIRECT_AGENCY',
  EUROPLAYAS = 'EUROPLAYAS',
  EXCITEHOLIDAYS = 'EXCITEHOLIDAYS',
  EZZEGO_1 = 'EZZEGO_1',
  GETAROOM = 'GETAROOM',
  HOME_AWAY = 'HOME_AWAY',
  HOTELDOBESTDAYTRAVEL = 'HOTELDOBESTDAYTRAVEL',
  HOTEL_BEDS = 'HOTEL_BEDS',
  HRS = 'HRS',
  JAC_TRAVEL = 'JAC_TRAVEL',
  JAL = 'JAL',
  JALAN = 'JALAN',
  JTB = 'JTB',
  JUMBOTOURS = 'JUMBOTOURS',
  MAGICROOMS = 'MAGICROOMS',
  MERCHANT = 'MERCHANT',
  MGBEDBANK = 'MGBEDBANK',
  MIKI = 'MIKI',
  MTS = 'MTS',
  NTA = 'NTA',
  NUITEE = 'NUITEE',
  OPAQUE = 'OPAQUE',
  OSTROVOK = 'OSTROVOK',
  PEGASUS = 'PEGASUS',
  RAKUTEN = 'RAKUTEN',
  RESTEL = 'RESTEL',
  ROOMER = 'ROOMER',
  SMYROOMS = 'SMYROOMS',
  SUNHOTELS = 'SUNHOTELS',
  TOURICO = 'TOURICO',
  TRAVELLANDA = 'TRAVELLANDA',
  TRAVELREPUBLIC = 'TRAVELREPUBLIC',
  VENERE = 'VENERE',
  VRBO = 'VRBO',
  WELCOME_BEDS = 'WELCOME_BEDS',
  WOORI = 'WOORI',
  WORLDHOTELLINK = 'WORLDHOTELLINK',
  WORLDSPAN = 'WORLDSPAN',
  WOTIF = 'WOTIF',
  YOUTRAVEL = 'YOUTRAVEL',
  ZUMATA = 'ZUMATA'
}
/** Indicate the shopping path of a given offer */
export enum ShoppingPathType {
  ATTACH = 'ATTACH',
  PACKAGE = 'PACKAGE',
  STANDALONE = 'STANDALONE'
}

export enum AmenityCategory {
  ACCESSIBLE_ROLL_IN_SHOWER = 'ACCESSIBLE_ROLL_IN_SHOWER',
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  ARCADE = 'ARCADE',
  BABYSITTING = 'BABYSITTING',
  BAR = 'BAR',
  BOWLING = 'BOWLING',
  BREAKFAST_AVAILABLE = 'BREAKFAST_AVAILABLE',
  BREAKFAST_NOT_AVAILABLE = 'BREAKFAST_NOT_AVAILABLE',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CHILDREN_CLUB = 'CHILDREN_CLUB',
  DAILY_HOUSEKEEPING = 'DAILY_HOUSEKEEPING',
  EXTRA_BED = 'EXTRA_BED',
  FITNESS_EQUIPMENT = 'FITNESS_EQUIPMENT',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_CANCEL = 'FREE_CANCEL',
  FREE_PARKING = 'FREE_PARKING',
  FREE_WELCOME_DRINK = 'FREE_WELCOME_DRINK',
  FREE_WIRED_INTERNET = 'FREE_WIRED_INTERNET',
  FRONT_DESK_24_HOURS = 'FRONT_DESK_24_HOURS',
  GROCERY = 'GROCERY',
  HIGH_SPEED_INTERNET = 'HIGH_SPEED_INTERNET',
  HOT_TUB = 'HOT_TUB',
  INTERNET_NOT_AVAILABLE = 'INTERNET_NOT_AVAILABLE',
  IN_ROOM_INTERNET = 'IN_ROOM_INTERNET',
  KIDS_POOL = 'KIDS_POOL',
  KITCHEN = 'KITCHEN',
  LAUNDRY = 'LAUNDRY',
  LIVING_AREA = 'LIVING_AREA',
  MICROWAVE = 'MICROWAVE',
  MINI_GOLF = 'MINI_GOLF',
  NON_REFUNDABLE = 'NON_REFUNDABLE',
  PARKING = 'PARKING',
  PETS_ALLOWED = 'PETS_ALLOWED',
  PLAYGROUND = 'PLAYGROUND',
  POOL = 'POOL',
  RESERVE_NOW_PAY_DEPOSIT = 'RESERVE_NOW_PAY_DEPOSIT',
  RESERVE_NOW_PAY_LATER = 'RESERVE_NOW_PAY_LATER',
  RESTAURANT_IN_HOTEL = 'RESTAURANT_IN_HOTEL',
  ROOM_SERVICE = 'ROOM_SERVICE',
  SMOKE_FREE = 'SMOKE_FREE',
  SOUNDPROOF_ROOM = 'SOUNDPROOF_ROOM',
  SPA_SERVICES_ON_SITE = 'SPA_SERVICES_ON_SITE',
  SPECIAL_DEAL = 'SPECIAL_DEAL',
  TENNIS_COURT = 'TENNIS_COURT',
  TOYS = 'TOYS',
  WATERSLIDE = 'WATERSLIDE',
  WIFI_SURCHARGE = 'WIFI_SURCHARGE',
  WIRED_INTERNET_SURCHARGE = 'WIRED_INTERNET_SURCHARGE'
}

export enum BadgeIcon {
  ACCESS_TIME = 'ACCESS_TIME',
  ADD = 'ADD',
  BUNDLED_SAVINGS_TAG_PLUS = 'BUNDLED_SAVINGS_TAG_PLUS',
  EXP29411_CTX = 'EXP29411_CTX',
  EXP29411_EBOOK = 'EXP29411_EBOOK',
  EXP29411_EXP = 'EXP29411_EXP',
  EXP29411_ORB = 'EXP29411_ORB',
  EXP29411_TVLY = 'EXP29411_TVLY',
  EXP29411_WOTIF = 'EXP29411_WOTIF',
  EXP29639_ORB = 'EXP29639_ORB',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  INFO_OUTLINE = 'INFO_OUTLINE',
  MIP_PRIMARY = 'MIP_PRIMARY',
  MIP_SECONDARY = 'MIP_SECONDARY',
  MOD = 'MOD',
  PLUS_CIRCLE = 'PLUS_CIRCLE',
  PLUS_CIRCLE_CTX = 'PLUS_CIRCLE_CTX',
  PLUS_CIRCLE_EBOOK = 'PLUS_CIRCLE_EBOOK',
  PLUS_CIRCLE_ORB = 'PLUS_CIRCLE_ORB',
  PLUS_CIRCLE_TVLY = 'PLUS_CIRCLE_TVLY',
  PLUS_CIRCLE_WOTIF = 'PLUS_CIRCLE_WOTIF',
  SMARTPHONE = 'SMARTPHONE'
}

export enum Theme {
  BRAND = 'BRAND',
  DEAL_ADD_ON = 'DEAL_ADD_ON',
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  INFO = 'INFO',
  LINK = 'LINK',
  LOYALTY = 'LOYALTY',
  NOTIFICATION = 'NOTIFICATION',
  SAVED = 'SAVED',
  SPONSORED = 'SPONSORED',
  SUCCESS = 'SUCCESS',
  SUCCESS_MEDIUM = 'SUCCESS_MEDIUM',
  SUPPLIER_PROMO = 'SUPPLIER_PROMO',
  URGENT = 'URGENT',
  VIEWED = 'VIEWED',
  VIP = 'VIP',
  VIP_ACCESS = 'VIP_ACCESS'
}

export enum PropertyCancellationPolicyType {
  NON_REFUNDABLE = 'NON_REFUNDABLE',
  REFUNDABLE_WITH_NO_PENALTY = 'REFUNDABLE_WITH_NO_PENALTY',
  REFUNDABLE_WITH_PENALTY = 'REFUNDABLE_WITH_PENALTY'
}

export enum RateDiscountType {
  MEMBER_DEAL = 'MEMBER_DEAL',
  MOBILE_EXCLUSIVE = 'MOBILE_EXCLUSIVE',
  REGULAR = 'REGULAR',
  TONIGHT_ONLY = 'TONIGHT_ONLY'
}

export enum FeeType {
  DEFAULT = 'DEFAULT',
  DEFAULT_SUPPLIER_COLLECTED = 'DEFAULT_SUPPLIER_COLLECTED',
  GROUPED_MANDATORY_FEES = 'GROUPED_MANDATORY_FEES',
  L26_TAX_BREAKOUT = 'L26_TAX_BREAKOUT',
  NORMAL = 'NORMAL',
  OTHER = 'OTHER',
  PER_PERSON_PER_NIGHT = 'PER_PERSON_PER_NIGHT',
  PROPERTY = 'PROPERTY',
  REFUNDABLE_DAMAGE_DEPOSIT = 'REFUNDABLE_DAMAGE_DEPOSIT',
  RESORT = 'RESORT'
}

export enum PropertyPaymentModel {
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_NOW = 'PAY_NOW'
}

export enum StrikeOutType {
  ATTACH = 'ATTACH',
  INVALID = 'INVALID',
  LOYALTY = 'LOYALTY',
  PACKAGE = 'PACKAGE',
  PRICE_SURVEY = 'PRICE_SURVEY',
  STANDALONE = 'STANDALONE'
}

export enum PricingSchemeType {
  DAILY_RATE = 'DAILY_RATE',
  TOTAL_RATE = 'TOTAL_RATE'
}

export enum SourceType {
  ESR = 'ESR',
  GDS = 'GDS'
}
/** Filters review results by category type */
export enum PropertyReviewCategory {
  BUSINESS_TRAVELERS = 'BUSINESS_TRAVELERS',
  COUPLES = 'COUPLES',
  EVERYONE = 'EVERYONE',
  FAMILIES = 'FAMILIES',
  GETAWAY_WITH_FRIENDS = 'GETAWAY_WITH_FRIENDS',
  GOLF = 'GOLF',
  OTHER = 'OTHER',
  OVERNIGHT_STAY = 'OVERNIGHT_STAY',
  PERSONAL_EVENT = 'PERSONAL_EVENT',
  SHOPPING = 'SHOPPING',
  SPA = 'SPA',
  STUDENTS = 'STUDENTS'
}
/** [Optional] Review filter type */
export enum PropertyReviewType {
  CRITICAL = 'CRITICAL',
  POSITIVE = 'POSITIVE'
}
/** [Optional] Hotel reviews sort types. Defaults to NEWEST_TO_OLDEST_BY_LANGUAGE */
export enum PropertyReviewSort {
  HIGHEST_TO_LOWEST_RATED = 'HIGHEST_TO_LOWEST_RATED',
  LOWEST_TO_HIGHEST_RATED = 'LOWEST_TO_HIGHEST_RATED',
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST',
  NEWEST_TO_OLDEST_BY_LANGUAGE = 'NEWEST_TO_OLDEST_BY_LANGUAGE',
  OLDEST_TO_NEWEST = 'OLDEST_TO_NEWEST',
  OLDEST_TO_NEWEST_BY_LANGUAGE = 'OLDEST_TO_NEWEST_BY_LANGUAGE'
}
/** Type that represents the amenity category icons for the property */
export enum PropertyAmenityCategoryType {
  ACCESSIBLE_ROLL_IN_SHOWER = 'ACCESSIBLE_ROLL_IN_SHOWER',
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  ARCADE = 'ARCADE',
  BABYSITTING = 'BABYSITTING',
  BAR = 'BAR',
  BOWLING = 'BOWLING',
  BREAKFAST_AVAILABLE = 'BREAKFAST_AVAILABLE',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CHILDREN_CLUB = 'CHILDREN_CLUB',
  DAILY_HOUSEKEEPING = 'DAILY_HOUSEKEEPING',
  EXTRA_BED = 'EXTRA_BED',
  FITNESS_EQUIPMENT = 'FITNESS_EQUIPMENT',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_PARKING = 'FREE_PARKING',
  FREE_WELCOME_DRINK = 'FREE_WELCOME_DRINK',
  FRONT_DESK_24_HOURS = 'FRONT_DESK_24_HOURS',
  GROCERY = 'GROCERY',
  HIGH_SPEED_INTERNET = 'HIGH_SPEED_INTERNET',
  HOT_TUB = 'HOT_TUB',
  IN_ROOM_INTERNET = 'IN_ROOM_INTERNET',
  KIDS_POOL = 'KIDS_POOL',
  KITCHEN = 'KITCHEN',
  LAUNDRY = 'LAUNDRY',
  LIVING_AREA = 'LIVING_AREA',
  MICROWAVE = 'MICROWAVE',
  MINI_GOLF = 'MINI_GOLF',
  PARKING = 'PARKING',
  PETS_ALLOWED = 'PETS_ALLOWED',
  PLAYGROUND = 'PLAYGROUND',
  POOL = 'POOL',
  RESTAURANT_IN_HOTEL = 'RESTAURANT_IN_HOTEL',
  ROOM_SERVICE = 'ROOM_SERVICE',
  SMOKE_FREE = 'SMOKE_FREE',
  SOUNDPROOF_ROOM = 'SOUNDPROOF_ROOM',
  SPA_SERVICES_ON_SITE = 'SPA_SERVICES_ON_SITE',
  SPECIAL_DEAL = 'SPECIAL_DEAL',
  TENNIS_COURT = 'TENNIS_COURT',
  TOYS = 'TOYS',
  WATERSLIDE = 'WATERSLIDE'
}

export enum PropertyAmenityType {
  ACCESSIBILITY = 'ACCESSIBILITY',
  BATHROOM = 'BATHROOM',
  BEDROOM = 'BEDROOM',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CONVENIENCES = 'CONVENIENCES',
  ENTERTAINMENT = 'ENTERTAINMENT',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  FOOD_DRINK = 'FOOD_DRINK',
  GUEST_SERVICES = 'GUEST_SERVICES',
  INTERNET = 'INTERNET',
  MORE = 'MORE',
  OUTDOOR = 'OUTDOOR',
  OUTDOOR_SPACE = 'OUTDOOR_SPACE',
  PARKING = 'PARKING',
  PROPERTY = 'PROPERTY',
  ROOM = 'ROOM',
  SPA = 'SPA',
  THINGS_TO_DO = 'THINGS_TO_DO'
}
/** The UDS icon used for the map marker */
export enum MapIconType {
  AIRPORT = 'AIRPORT',
  CIRCLE = 'CIRCLE',
  HOTEL = 'HOTEL',
  LANDMARK = 'LANDMARK',
  METRO = 'METRO',
  RESTAURANT = 'RESTAURANT',
  SOLD_OUT = 'SOLD_OUT',
  TRAIN = 'TRAIN'
}
/** The type of map marker */
export enum MarkerType {
  HOTEL = 'HOTEL',
  POI = 'POI'
}
/** ADs related property search options */
export enum Listings {
  ADS_ONLY = 'ADS_ONLY'
}
/** Points related property search options */
export enum Points {
  SHOP_WITHOUT_POINTS = 'SHOP_WITHOUT_POINTS',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}

export enum PackageType {
  FLIGHT_CAR = 'FLIGHT_CAR',
  FLIGHT_HOTEL = 'FLIGHT_HOTEL',
  FLIGHT_HOTEL_CAR = 'FLIGHT_HOTEL_CAR',
  HOTEL_CAR = 'HOTEL_CAR'
}
/** Describes what kind of action being described. Copy for example describes the coupon code copy behavior. Authwindow shows the login/signup dialog. */
export enum ActionDetailsType {
  AUTHWINDOW = 'AUTHWINDOW',
  COPY = 'COPY',
  FREE_LX = 'FREE_LX',
  OPEN = 'OPEN',
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS'
}
/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum MessageType {
  ADDON = 'ADDON',
  COMPRESSION = 'COMPRESSION',
  COUPON = 'COUPON',
  DOUBLE_POINTS = 'DOUBLE_POINTS',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  FREE_LX = 'FREE_LX',
  LEGAL = 'LEGAL',
  LOGIN = 'LOGIN',
  LOYALTY = 'LOYALTY',
  OVERFILTERED = 'OVERFILTERED',
  VACATION_RENTALS = 'VACATION_RENTALS'
}
/** Enum of the units of measure and their abbreviations */
export enum DistanceUnit {
  KILOMETER = 'KILOMETER',
  MILE = 'MILE'
}

export enum OfferAttributeType {
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  NO_CC_REQUIRED = 'NO_CC_REQUIRED',
  PAYMENT_CHOICE = 'PAYMENT_CHOICE',
  VIP = 'VIP'
}

export enum PropertyPaymentFlags {
  ARTIFICIALLY_FENCED_RATE = 'ARTIFICIALLY_FENCED_RATE',
  MIXED_RATE_PLAN = 'MIXED_RATE_PLAN',
  NO_CREDIT_CARD = 'NO_CREDIT_CARD'
}
/** A rough measure of the percentage of properties that are sold out in the destination region as calculated by the Urgency Service. */
export enum CompressionLevel {
  CAP = 'CAP',
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  NA = 'NA'
}
/** UDS token based list of icons */
export enum UdsIcon {
  ACCESSIBLE = 'ACCESSIBLE',
  ACCESS_TIME = 'ACCESS_TIME',
  ACCOUNT_CIRCLE = 'ACCOUNT_CIRCLE',
  AC_UNIT = 'AC_UNIT',
  ADD = 'ADD',
  ADD_A_PHOTO = 'ADD_A_PHOTO',
  AIRLINE_SEAT_RECLINE_EXTRA = 'AIRLINE_SEAT_RECLINE_EXTRA',
  AIRPORT_SHUTTLE = 'AIRPORT_SHUTTLE',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  APPS = 'APPS',
  ARROW_BACK = 'ARROW_BACK',
  ARROW_DOWNWARD = 'ARROW_DOWNWARD',
  ARROW_DROP_DOWN = 'ARROW_DROP_DOWN',
  ARROW_DROP_UP = 'ARROW_DROP_UP',
  ARROW_FORWARD = 'ARROW_FORWARD',
  ARROW_UPWARD = 'ARROW_UPWARD',
  ASSIGNMENT = 'ASSIGNMENT',
  ATTACH_FILE = 'ATTACH_FILE',
  AUTO_RENEW = 'AUTO_RENEW',
  BATHROOM = 'BATHROOM',
  BBQ_GRILL = 'BBQ_GRILL',
  BED = 'BED',
  BEDDING__BUNK = 'BEDDING__BUNK',
  BEDDING__CRIB = 'BEDDING__CRIB',
  BEDDING__DOUBLE = 'BEDDING__DOUBLE',
  BEDDING__KING = 'BEDDING__KING',
  BEDDING__QUEEN = 'BEDDING__QUEEN',
  BEDDING__SINGLE = 'BEDDING__SINGLE',
  BEDDING__SOFA = 'BEDDING__SOFA',
  BEDDING__TRUNDLE = 'BEDDING__TRUNDLE',
  BRIGHTNESS_1 = 'BRIGHTNESS_1',
  BRIGHTNESS_1_HALF = 'BRIGHTNESS_1_HALF',
  BUNDLED_SAVINGS_PLUS = 'BUNDLED_SAVINGS_PLUS',
  BUSINESS_CENTER = 'BUSINESS_CENTER',
  CALENDAR_ADD = 'CALENDAR_ADD',
  CAMERA_ALT = 'CAMERA_ALT',
  CANCEL = 'CANCEL',
  CARD_GIFTCARD = 'CARD_GIFTCARD',
  CHAT = 'CHAT',
  CHAT_BUBBLE = 'CHAT_BUBBLE',
  CHECK_CIRCLE = 'CHECK_CIRCLE',
  CHEVRON_LEFT = 'CHEVRON_LEFT',
  CHEVRON_RIGHT = 'CHEVRON_RIGHT',
  CHILD = 'CHILD',
  CHILD_FRIENDLY = 'CHILD_FRIENDLY',
  CLOSE = 'CLOSE',
  CLOUD_OFF = 'CLOUD_OFF',
  COMMENT = 'COMMENT',
  COMPUTER = 'COMPUTER',
  CREDIT_CARD = 'CREDIT_CARD',
  DELETE = 'DELETE',
  DIALPAD = 'DIALPAD',
  DIMENSION = 'DIMENSION',
  DIRECTIONS = 'DIRECTIONS',
  DIRECTIONS_BOAT = 'DIRECTIONS_BOAT',
  DIRECTIONS_BUS = 'DIRECTIONS_BUS',
  DIRECTIONS_CAR = 'DIRECTIONS_CAR',
  DIRECTIONS_WALK = 'DIRECTIONS_WALK',
  DISTANCE = 'DISTANCE',
  DONE = 'DONE',
  DRYER = 'DRYER',
  EMAIL = 'EMAIL',
  ERROR = 'ERROR',
  EXPAND_LESS = 'EXPAND_LESS',
  EXPAND_MORE = 'EXPAND_MORE',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  FAVORITE = 'FAVORITE',
  FAVORITE_BORDER = 'FAVORITE_BORDER',
  FIREPLACE = 'FIREPLACE',
  FITNESS_CENTER = 'FITNESS_CENTER',
  FLASH_ON = 'FLASH_ON',
  FLIGHT = 'FLIGHT',
  FLIGHT_LAND = 'FLIGHT_LAND',
  FLIGHT_TAKEOFF = 'FLIGHT_TAKEOFF',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  HEADSET_MIC = 'HEADSET_MIC',
  HELP = 'HELP',
  HISTORY = 'HISTORY',
  HOME = 'HOME',
  HOT_TUB = 'HOT_TUB',
  HOURGLASS_EMPTY = 'HOURGLASS_EMPTY',
  IMAGE = 'IMAGE',
  INFO = 'INFO',
  INFO_OUTLINE = 'INFO_OUTLINE',
  INSURANCE = 'INSURANCE',
  INSURANCE_CARS = 'INSURANCE_CARS',
  INSURANCE_CRUISE = 'INSURANCE_CRUISE',
  INSURANCE_FLIGHTS = 'INSURANCE_FLIGHTS',
  INSURANCE_HOTELS = 'INSURANCE_HOTELS',
  INSURANCE_NONE = 'INSURANCE_NONE',
  KIDS_ACTIVITIES = 'KIDS_ACTIVITIES',
  KITCHEN = 'KITCHEN',
  LOB_ACTIVITIES = 'LOB_ACTIVITIES',
  LOB_ALL_INCLUSIVE_VACATIONS = 'LOB_ALL_INCLUSIVE_VACATIONS',
  LOB_CARS = 'LOB_CARS',
  LOB_CRUISE = 'LOB_CRUISE',
  LOB_FLIGHTS = 'LOB_FLIGHTS',
  LOB_HOTELS = 'LOB_HOTELS',
  LOB_PACKAGES = 'LOB_PACKAGES',
  LOB_VACATION_RENTALS = 'LOB_VACATION_RENTALS',
  LOCAL_ACTIVITY = 'LOCAL_ACTIVITY',
  LOCAL_BAR = 'LOCAL_BAR',
  LOCAL_CAFE = 'LOCAL_CAFE',
  LOCAL_CONVENIENCE_STORE = 'LOCAL_CONVENIENCE_STORE',
  LOCAL_DINING = 'LOCAL_DINING',
  LOCAL_LAUNDRY_SERVICE = 'LOCAL_LAUNDRY_SERVICE',
  LOCAL_OFFER = 'LOCAL_OFFER',
  LOCAL_PARKING = 'LOCAL_PARKING',
  LOCAL_TAXI = 'LOCAL_TAXI',
  LOCATION_CITY = 'LOCATION_CITY',
  LOCK = 'LOCK',
  MAP = 'MAP',
  MENU = 'MENU',
  MIC = 'MIC',
  MIC_OFF = 'MIC_OFF',
  MOD = 'MOD',
  MODE_EDIT = 'MODE_EDIT',
  MONETIZATION_ON = 'MONETIZATION_ON',
  MONEY = 'MONEY',
  MORE_HORIZ = 'MORE_HORIZ',
  MORE_VERT = 'MORE_VERT',
  MY_LOCATION = 'MY_LOCATION',
  NATURE = 'NATURE',
  NAVIGATE_BEFORE = 'NAVIGATE_BEFORE',
  NAVIGATE_NEXT = 'NAVIGATE_NEXT',
  NOTIFICATIONS = 'NOTIFICATIONS',
  ONDEMAND_ENTERTAINMENT = 'ONDEMAND_ENTERTAINMENT',
  OPEN_IN_NEW = 'OPEN_IN_NEW',
  PATIO = 'PATIO',
  PAUSE = 'PAUSE',
  PEOPLE = 'PEOPLE',
  PERSON = 'PERSON',
  PETS = 'PETS',
  PHONE = 'PHONE',
  PHOTO_LIBRARY = 'PHOTO_LIBRARY',
  PHYSICAL_ACTIVITY_LEVEL = 'PHYSICAL_ACTIVITY_LEVEL',
  PLACE = 'PLACE',
  PLAY_ARROW = 'PLAY_ARROW',
  POOL = 'POOL',
  POWER = 'POWER',
  PRINT = 'PRINT',
  RECEIPT = 'RECEIPT',
  REDEEM = 'REDEEM',
  REFRESH = 'REFRESH',
  REMOVE = 'REMOVE',
  ROOM = 'ROOM',
  ROOM_SERVICE = 'ROOM_SERVICE',
  RSS_FEED = 'RSS_FEED',
  SEARCH = 'SEARCH',
  SECURITY = 'SECURITY',
  SEND = 'SEND',
  SENTIMENT_1 = 'SENTIMENT_1',
  SENTIMENT_1_FILL = 'SENTIMENT_1_FILL',
  SENTIMENT_2 = 'SENTIMENT_2',
  SENTIMENT_2_FILL = 'SENTIMENT_2_FILL',
  SENTIMENT_3 = 'SENTIMENT_3',
  SENTIMENT_3_FILL = 'SENTIMENT_3_FILL',
  SENTIMENT_4 = 'SENTIMENT_4',
  SENTIMENT_4_FILL = 'SENTIMENT_4_FILL',
  SENTIMENT_5 = 'SENTIMENT_5',
  SENTIMENT_5_FILL = 'SENTIMENT_5_FILL',
  SETTINGS = 'SETTINGS',
  SHARE = 'SHARE',
  SHOPPING_CART = 'SHOPPING_CART',
  SKI = 'SKI',
  SKIP_THE_LINE = 'SKIP_THE_LINE',
  SMARTPHONE = 'SMARTPHONE',
  SMOKE_FREE = 'SMOKE_FREE',
  SPA = 'SPA',
  STAR = 'STAR',
  STAR_HALF = 'STAR_HALF',
  SUBDIRECTORY_ARROW_RIGHT = 'SUBDIRECTORY_ARROW_RIGHT',
  SWAP_VERT = 'SWAP_VERT',
  TERRAIN = 'TERRAIN',
  THUMB_UP = 'THUMB_UP',
  TIMELINE = 'TIMELINE',
  TODAY = 'TODAY',
  TRAIN = 'TRAIN',
  TRANSLATE = 'TRANSLATE',
  TRENDING_UP = 'TRENDING_UP',
  TUNE = 'TUNE',
  TV = 'TV',
  VIEW_LIST = 'VIEW_LIST',
  VISIBILITY = 'VISIBILITY',
  VISIBILITY_OFF = 'VISIBILITY_OFF',
  VPN_KEY = 'VPN_KEY',
  WARNING = 'WARNING',
  WATER = 'WATER',
  WEATHER_AFTERNOON = 'WEATHER_AFTERNOON',
  WEATHER_CLOUDY = 'WEATHER_CLOUDY',
  WEATHER_COLD = 'WEATHER_COLD',
  WEATHER_DAY_INTERMITTENT_CLOUDS = 'WEATHER_DAY_INTERMITTENT_CLOUDS',
  WEATHER_DAY_MOSTLY_CLOUDY = 'WEATHER_DAY_MOSTLY_CLOUDY',
  WEATHER_DAY_MOSTLY_FLURRIES = 'WEATHER_DAY_MOSTLY_FLURRIES',
  WEATHER_DAY_MOSTLY_SHOWERS = 'WEATHER_DAY_MOSTLY_SHOWERS',
  WEATHER_DAY_MOSTLY_SNOW = 'WEATHER_DAY_MOSTLY_SNOW',
  WEATHER_DAY_MOSTLY_THUNDERSTORM = 'WEATHER_DAY_MOSTLY_THUNDERSTORM',
  WEATHER_DAY_PARTLY_FLURRIES = 'WEATHER_DAY_PARTLY_FLURRIES',
  WEATHER_DAY_PARTLY_SHOWERS = 'WEATHER_DAY_PARTLY_SHOWERS',
  WEATHER_DAY_PARTLY_THUNDERSTORM = 'WEATHER_DAY_PARTLY_THUNDERSTORM',
  WEATHER_DREARY = 'WEATHER_DREARY',
  WEATHER_EARLY_MORNING = 'WEATHER_EARLY_MORNING',
  WEATHER_EVENING_INTERMITTENT = 'WEATHER_EVENING_INTERMITTENT',
  WEATHER_FLURRIES = 'WEATHER_FLURRIES',
  WEATHER_FOG = 'WEATHER_FOG',
  WEATHER_FREEZING_RAIN = 'WEATHER_FREEZING_RAIN',
  WEATHER_HAZY_MOON = 'WEATHER_HAZY_MOON',
  WEATHER_HAZY_SUN = 'WEATHER_HAZY_SUN',
  WEATHER_HOT = 'WEATHER_HOT',
  WEATHER_ICE = 'WEATHER_ICE',
  WEATHER_MOON = 'WEATHER_MOON',
  WEATHER_MORNING = 'WEATHER_MORNING',
  WEATHER_MOSTLY_MOON = 'WEATHER_MOSTLY_MOON',
  WEATHER_MOSTLY_SUNNY = 'WEATHER_MOSTLY_SUNNY',
  WEATHER_NIGHT_MOSTLY_CLOUDY = 'WEATHER_NIGHT_MOSTLY_CLOUDY',
  WEATHER_NIGHT_MOSTLY_FLURRIES = 'WEATHER_NIGHT_MOSTLY_FLURRIES',
  WEATHER_NIGHT_MOSTLY_SHOWERS = 'WEATHER_NIGHT_MOSTLY_SHOWERS',
  WEATHER_NIGHT_MOSTLY_SNOW = 'WEATHER_NIGHT_MOSTLY_SNOW',
  WEATHER_NIGHT_MOSTLY_THUNDERSTORMS = 'WEATHER_NIGHT_MOSTLY_THUNDERSTORMS',
  WEATHER_NIGHT_PARTLY_SHOWERS = 'WEATHER_NIGHT_PARTLY_SHOWERS',
  WEATHER_NIGHT_PARTLY_THUNDERSTORM = 'WEATHER_NIGHT_PARTLY_THUNDERSTORM',
  WEATHER_PARTLY_MOON = 'WEATHER_PARTLY_MOON',
  WEATHER_PARTLY_SUNNY = 'WEATHER_PARTLY_SUNNY',
  WEATHER_RAIN = 'WEATHER_RAIN',
  WEATHER_RAIN_SNOW = 'WEATHER_RAIN_SNOW',
  WEATHER_SHOWERS = 'WEATHER_SHOWERS',
  WEATHER_SLEET = 'WEATHER_SLEET',
  WEATHER_SNOW = 'WEATHER_SNOW',
  WEATHER_SUN = 'WEATHER_SUN',
  WEATHER_THUNDERSTORM = 'WEATHER_THUNDERSTORM',
  WEATHER_WIND = 'WEATHER_WIND',
  WIFI = 'WIFI',
  WORK = 'WORK',
  ZOOM_IN = 'ZOOM_IN',
  ZOOM_OUT = 'ZOOM_OUT'
}

export enum ProductQuestionTopic {
  HOTEL = 'HOTEL'
}

export enum QuestionSortType {
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST',
  OLDEST_TO_NEWEST = 'OLDEST_TO_NEWEST'
}

export enum KeyPhrasesClientType {
  FILTER = 'FILTER',
  SNIPPET = 'SNIPPET'
}

export enum TripIntentPersonType {
  ADULT = 'ADULT',
  CHILD = 'CHILD'
}

export enum HistoryType {
  ACTIVITY_DETAIL = 'ACTIVITY_DETAIL',
  ACTIVITY_SEARCH = 'ACTIVITY_SEARCH',
  CAR_DETAIL = 'CAR_DETAIL',
  CAR_SEARCH = 'CAR_SEARCH',
  CRUISE_SEARCH = 'CRUISE_SEARCH',
  FLIGHT_DETAIL = 'FLIGHT_DETAIL',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  PACKAGE_SEARCH = 'PACKAGE_SEARCH',
  PROPERTY_DETAIL = 'PROPERTY_DETAIL',
  PROPERTY_SEARCH = 'PROPERTY_SEARCH'
}

export enum FunnelLocation {
  CHECKOUT = 'CHECKOUT',
  CHECKOUT_ERROR = 'CHECKOUT_ERROR',
  CONFIRMATION = 'CONFIRMATION',
  DETAILS = 'DETAILS',
  ENTRY = 'ENTRY',
  FEATURES = 'FEATURES',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  POST_BOOKING = 'POST_BOOKING',
  SEARCH_RESULTS = 'SEARCH_RESULTS',
  SYSTEM = 'SYSTEM',
  USER = 'USER'
}

export enum ExpLineOfBusiness {
  ACTIVITIES = 'ACTIVITIES',
  CAR = 'CAR',
  CRUISES = 'CRUISES',
  FLIGHT = 'FLIGHT',
  GROUNDTRANSFERS = 'GROUNDTRANSFERS',
  HOTEL = 'HOTEL',
  PACKAGES = 'PACKAGES',
  RAILS = 'RAILS',
  UNCLASSIFIED = 'UNCLASSIFIED'
}

export enum NotificationLocation {
  AFTER_HEADER = 'AFTER_HEADER',
  PRE_HEADER = 'PRE_HEADER'
}
/** The text style to apply to strings */
export enum CustomerNotificationPhrasePartStyle {
  EMPHASIS = 'EMPHASIS',
  IMPORTANT = 'IMPORTANT',
  STANDARD = 'STANDARD'
}
/** Represents the target of the link */
export enum CustomerNotificationLinkTarget {
  NEW_TAB = 'NEW_TAB',
  SAME_TAB = 'SAME_TAB'
}

export enum CustomerNotificationType {
  APP_DOWNLOAD = 'APP_DOWNLOAD',
  APP_HERO = 'APP_HERO',
  GDPR = 'GDPR',
  NONE = 'NONE',
  TRAVEL_ADVISORY = 'TRAVEL_ADVISORY'
}
/** Gender of the customer */
export enum CustomerGender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  UNKNOWN = 'UNKNOWN'
}
/** Available Flight Seating Preferences */
export enum SeatingPreferenceType {
  AISLE = 'AISLE',
  NO_PREFERENCE = 'NO_PREFERENCE',
  WINDOW = 'WINDOW'
}
/** Status of the Invite for travel Arranger / Arrangee */
export enum InviteStatus {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  PENDING = 'PENDING',
  TERMINATED = 'TERMINATED'
}
/** Type of the Invite(Arranger/Arrangee) */
export enum InviteType {
  INVITE_BY_ARRANGEE = 'INVITE_BY_ARRANGEE',
  INVITE_BY_ARRANGER = 'INVITE_BY_ARRANGER'
}

export enum RewardsPointSelectionEnum {
  APPLY_REWARD_POINT = 'APPLY_REWARD_POINT',
  DO_NOT_APPLY_REWARD_POINTS = 'DO_NOT_APPLY_REWARD_POINTS'
}

export enum CarActionType {
  DISMISS = 'DISMISS',
  GO_TO_CHECKOUT = 'GO_TO_CHECKOUT',
  GO_TO_DETAILS = 'GO_TO_DETAILS',
  GO_TO_PACKAGES = 'GO_TO_PACKAGES',
  LOAD_MORE = 'LOAD_MORE',
  REFRESH = 'REFRESH'
}
/** Car offer sort types */
export enum CarsSortOption {
  CUSTOMER_RATING_LOW_TO_HIGH = 'CUSTOMER_RATING_LOW_TO_HIGH',
  MOST_POPULAR = 'MOST_POPULAR',
  RECOMMENDED = 'RECOMMENDED',
  TOTAL_PRICE_LOW_TO_HIGH = 'TOTAL_PRICE_LOW_TO_HIGH'
}

export enum CarLabelTheme {
  CLICKABLE = 'CLICKABLE'
}

export enum CarBadgeDeal {
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  DEAL_MEMBERSHIP_PROGRAM = 'DEAL_MEMBERSHIP_PROGRAM'
}

export enum BookingStatus {
  ANY = 'ANY',
  BOOKED = 'BOOKED',
  CANCELLED = 'CANCELLED',
  PENDING = 'PENDING',
  SAVED = 'SAVED'
}
/** The text direction of the locale e.g. ltr or rtl */
export enum TextDirection {
  LTR = 'LTR',
  RTL = 'RTL'
}

export enum TemporaryFlightTripType {
  MULTI_DESTINATION = 'MULTI_DESTINATION',
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP'
}

export enum ProductType {
  ARTICLE = 'ARTICLE',
  CAR_DETAILS = 'CAR_DETAILS',
  DESTINATION = 'DESTINATION',
  DESTINATION_EXPERIENCE = 'DESTINATION_EXPERIENCE',
  EXPERIENCE = 'EXPERIENCE',
  EXPERT_TIP = 'EXPERT_TIP',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  LX_DETAILS = 'LX_DETAILS',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POI_GAIA = 'POI_GAIA',
  PROPERTY_DETAILS = 'PROPERTY_DETAILS'
}
/** Represent all the possible trip types */
export enum FlightsTripType {
  MULTI_DESTINATION = 'MULTI_DESTINATION',
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP'
}
/** cabin class chosen in flight */
export enum FlightsCabinClass {
  BUSINESS = 'BUSINESS',
  COACH = 'COACH',
  FIRST = 'FIRST',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY'
}
/** Represents the state the client wants to query */
export enum FlightsQueryState {
  LOADED = 'LOADED',
  LOADING = 'LOADING'
}
/** Enum representing the various time slots in a day */
export enum FlightsTimeOfDay {
  AFTERNOON = 'AFTERNOON',
  EARLY_MORNING = 'EARLY_MORNING',
  EVENING = 'EVENING',
  MORNING = 'MORNING'
}
/** Enum class to represent the operation associated with num of stops */
export enum FlightsStopFilterOperation {
  EQUAL = 'EQUAL',
  GREATER_THAN_EQUAL = 'GREATER_THAN_EQUAL',
  LESS_THAN_EQUAL = 'LESS_THAN_EQUAL'
}
/** Represent all the possible advanced filter types */
export enum FlightsAdvancedFilterType {
  NONSTOP = 'NONSTOP',
  REFUNDABLE = 'REFUNDABLE'
}
/** Enum which lists the sort orders */
export enum FlightsSortOrder {
  DECREASING = 'DECREASING',
  INCREASING = 'INCREASING'
}
/** Enum class which lists all the supported sorting criteria */
export enum FlightsSortType {
  ARRIVAL = 'ARRIVAL',
  DEPARTURE = 'DEPARTURE',
  DURATION = 'DURATION',
  PRICE = 'PRICE',
  RECOMMENDED = 'RECOMMENDED'
}
/** Represent all the possible traveler types */
export enum FlightsTravelerType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT_IN_LAP = 'INFANT_IN_LAP',
  INFANT_IN_SEAT = 'INFANT_IN_SEAT'
}
/** The text style to apply to strings */
export enum FlightsPhrasePartStyle {
  EMPHASIS = 'EMPHASIS',
  IMPORTANT = 'IMPORTANT',
  STANDARD = 'STANDARD'
}
/** Describes the type of actionable button. Types reference UDS tokens for buttons. */
export enum FlightsActionDisplayType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY'
}
/** Available action types an actionable element */
export enum FlightsActionType {
  DISMISS = 'DISMISS',
  GO_TO_DETAILS = 'GO_TO_DETAILS',
  GO_TO_NEXT_JOURNEY = 'GO_TO_NEXT_JOURNEY',
  GO_TO_PACKAGES = 'GO_TO_PACKAGES',
  LOAD_CROSS_SELL_DIALOG = 'LOAD_CROSS_SELL_DIALOG',
  LOAD_STANDARD_OFFER_FARE_RULE_MODULE = 'LOAD_STANDARD_OFFER_FARE_RULE_MODULE',
  REFRESH = 'REFRESH'
}
/** Represents the type of animation the dialog will use when displayed */
export enum FlightsDialogAnimation {
  FADE = 'FADE',
  NONE = 'NONE'
}
/** Represents the display of progress bar when the results are loading */
export enum FlightsProgressBarDisplay {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED'
}

export enum FlightsSearchFormErrorType {
  CHILD_AGE_MISSING = 'CHILD_AGE_MISSING',
  DATE_BEFORE_PREVIOUS_DATE = 'DATE_BEFORE_PREVIOUS_DATE',
  DATE_NOT_IN_VALID_RANGE = 'DATE_NOT_IN_VALID_RANGE',
  DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE = 'DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE',
  INFANT_AGE_MISSING = 'INFANT_AGE_MISSING',
  INVALID_DATE_FORMAT = 'INVALID_DATE_FORMAT',
  INVALID_TRAVELER_COUNT = 'INVALID_TRAVELER_COUNT',
  LESS_THAN_MINIMUM_ADULT = 'LESS_THAN_MINIMUM_ADULT',
  LOCATION_EMPTY = 'LOCATION_EMPTY',
  LOCATION_SAME = 'LOCATION_SAME',
  MAX_STAY_DURATION_ERROR = 'MAX_STAY_DURATION_ERROR',
  SAME_CITY = 'SAME_CITY',
  SPECIAL_CHARACTER_NOT_ALLOWED = 'SPECIAL_CHARACTER_NOT_ALLOWED',
  TOO_SHORT_AIRPORT_STRING = 'TOO_SHORT_AIRPORT_STRING',
  UNATTENDED_INFANT_IN_LAP = 'UNATTENDED_INFANT_IN_LAP',
  UNATTENDED_INFANT_IN_SEAT = 'UNATTENDED_INFANT_IN_SEAT'
}

export enum PoiMapItemCategory {
  LX = 'LX',
  RESTAURANT = 'RESTAURANT'
}

export enum UserCoordinateType {
  AIRPORT = 'AIRPORT',
  PROPERTY = 'PROPERTY'
}

export enum PoiMapItemCardType {
  POI_MAP_ITEM_SUMMARY_CARD = 'POI_MAP_ITEM_SUMMARY_CARD'
}

export enum PoiMapPinType {
  AIRPORT = 'AIRPORT',
  POI = 'POI',
  PROPERTY = 'PROPERTY'
}

export enum PageType {
  AIRLINE_AIRPORT = 'AIRLINE_AIRPORT',
  AIRLINE_FLIGHT_INFOSITE = 'AIRLINE_FLIGHT_INFOSITE',
  AIRLINE_GEO = 'AIRLINE_GEO',
  AIRLINE_OND_AIRPORT = 'AIRLINE_OND_AIRPORT',
  ALTERNATIVE_ACCOMMODATIONS = 'ALTERNATIVE_ACCOMMODATIONS',
  ALTERNATIVE_ACCOMMODATIONS_HUB_LAUNCH = 'ALTERNATIVE_ACCOMMODATIONS_HUB_LAUNCH',
  CAR_RENTAL_DESTINATIONS = 'CAR_RENTAL_DESTINATIONS',
  CAR_RENTAL_DESTINATION_SUPPLIERS = 'CAR_RENTAL_DESTINATION_SUPPLIERS',
  CAR_RENTAL_GUIDE = 'CAR_RENTAL_GUIDE',
  CAR_RENTAL_GUIDE_AIRPORT = 'CAR_RENTAL_GUIDE_AIRPORT',
  CAR_RENTAL_GUIDE_CAR_CLASS = 'CAR_RENTAL_GUIDE_CAR_CLASS',
  CAR_RENTAL_GUIDE_SUPPLIERS = 'CAR_RENTAL_GUIDE_SUPPLIERS',
  CAR_RENTAL_SUPPLIER_LOCATIONS = 'CAR_RENTAL_SUPPLIER_LOCATIONS',
  CRUISE_DEPARTURE_PORT = 'CRUISE_DEPARTURE_PORT',
  CRUISE_DESTINATIONS = 'CRUISE_DESTINATIONS',
  CRUISE_LINES = 'CRUISE_LINES',
  CRUISE_LINE_INFORMATION = 'CRUISE_LINE_INFORMATION',
  CRUISE_SHIP_INFORMATION = 'CRUISE_SHIP_INFORMATION',
  CRUISE_THEME_INFORMATION = 'CRUISE_THEME_INFORMATION',
  DESTINATION_DISCOVERY = 'DESTINATION_DISCOVERY',
  DESTINATION_DISCOVERY_WHERE_TO_STAY = 'DESTINATION_DISCOVERY_WHERE_TO_STAY',
  DESTINATION_EXPERIENCE = 'DESTINATION_EXPERIENCE',
  DESTINATION_TRAVEL_GUIDES = 'DESTINATION_TRAVEL_GUIDES',
  EXPERIENCE_DISCOVERY = 'EXPERIENCE_DISCOVERY',
  FLIGHT_DESTINATIONS = 'FLIGHT_DESTINATIONS',
  FLIGHT_GENERIC_PAGE = 'FLIGHT_GENERIC_PAGE',
  FLIGHT_OND_AIRPORT = 'FLIGHT_OND_AIRPORT',
  FLIGHT_OND_CITY = 'FLIGHT_OND_CITY',
  FLIGHT_OND_IATA = 'FLIGHT_OND_IATA',
  FLIGHT_ORIGIN_AIRPORT = 'FLIGHT_ORIGIN_AIRPORT',
  FLIGHT_ORIGIN_CITY = 'FLIGHT_ORIGIN_CITY',
  HOTELS_AFFINITY = 'HOTELS_AFFINITY',
  HOTELS_NEAR = 'HOTELS_NEAR',
  HOTEL_DESTINATIONS = 'HOTEL_DESTINATIONS',
  HOTEL_FILTER_DESTINATIONS = 'HOTEL_FILTER_DESTINATIONS',
  HOTEL_INFORMATION = 'HOTEL_INFORMATION',
  HOTEL_REVIEWS = 'HOTEL_REVIEWS',
  LOCAL_EXPERT_NEAR_ME = 'LOCAL_EXPERT_NEAR_ME',
  NEIGHBORHOOD_DISCOVERY = 'NEIGHBORHOOD_DISCOVERY',
  SEM_INTENT = 'SEM_INTENT',
  STOREFRONT_ACTIVITIES = 'STOREFRONT_ACTIVITIES',
  STOREFRONT_CARS = 'STOREFRONT_CARS',
  STOREFRONT_FLIGHTS = 'STOREFRONT_FLIGHTS',
  STOREFRONT_HOMEPAGE = 'STOREFRONT_HOMEPAGE',
  STOREFRONT_HOTELS = 'STOREFRONT_HOTELS',
  STOREFRONT_PACKAGES = 'STOREFRONT_PACKAGES',
  THEME_VACATIONS = 'THEME_VACATIONS',
  THEME_VACATIONS_DESTINATION = 'THEME_VACATIONS_DESTINATION',
  TRAIN_OND_CITY = 'TRAIN_OND_CITY',
  TRAVEL_GUIDE_ACCOMMODATION = 'TRAVEL_GUIDE_ACCOMMODATION',
  TRAVEL_GUIDE_ACTIVITIES = 'TRAVEL_GUIDE_ACTIVITIES',
  TRAVEL_GUIDE_AIRLINES = 'TRAVEL_GUIDE_AIRLINES',
  TRAVEL_GUIDE_AIRPORTS = 'TRAVEL_GUIDE_AIRPORTS',
  TRAVEL_GUIDE_CAR_RENTAL_COMPANY = 'TRAVEL_GUIDE_CAR_RENTAL_COMPANY',
  TRAVEL_GUIDE_CITY_ALL_HOTELS = 'TRAVEL_GUIDE_CITY_ALL_HOTELS',
  TRAVEL_GUIDE_CRUISE = 'TRAVEL_GUIDE_CRUISE',
  TRAVEL_GUIDE_FILTER_HOTELS = 'TRAVEL_GUIDE_FILTER_HOTELS',
  TRAVEL_GUIDE_FLIGHTS = 'TRAVEL_GUIDE_FLIGHTS',
  TRAVEL_GUIDE_HOTELS = 'TRAVEL_GUIDE_HOTELS',
  TRAVEL_GUIDE_VACATION_RENTALS = 'TRAVEL_GUIDE_VACATION_RENTALS',
  URL_MAPPING = 'URL_MAPPING',
  VACATION_ATTRACTION = 'VACATION_ATTRACTION',
  VACATION_RENTAL_DESTINATIONS = 'VACATION_RENTAL_DESTINATIONS'
}

export enum GeoTypeFilter {
  AIRPORT = 'AIRPORT',
  NEARBY_CITY = 'NEARBY_CITY',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POINT_OF_INTEREST = 'POINT_OF_INTEREST',
  RECOMMENDED_CITY = 'RECOMMENDED_CITY'
}

export enum CampaignProductType {
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL',
  PACKAGE = 'PACKAGE'
}

export enum CampaignOfferBadgeType {
  DEFAULT = 'DEFAULT',
  DISCOUNT = 'DISCOUNT'
}

export enum RecommendedType {
  DESTINATIONS = 'DESTINATIONS',
  OFFERS = 'OFFERS'
}

export enum InsuranceMutationStatus {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS'
}

export enum InsuranceMutationType {
  ADD_INSURANCE = 'ADD_INSURANCE',
  REMOVE_INSURANCE = 'REMOVE_INSURANCE'
}

export enum PaymentTokenType {
  CREDIT_CARD = 'CREDIT_CARD',
  STORED_CARD = 'STORED_CARD'
}

export enum ConversationsOperationResult {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

export enum CartFlightSearchType {
  MULTI_CITY = 'MULTI_CITY',
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP'
}

export enum CartTtl {
  FIVE_MINUTES = 'FIVE_MINUTES',
  SEVEN_DAYS = 'SEVEN_DAYS',
  TWELVE_HOURS = 'TWELVE_HOURS'
}
/** Possible equipment requested by the customer */
export enum SpecialEquipment {
  ADDITIONAL_DRIVER = 'ADDITIONAL_DRIVER',
  BICYCLE_RACK = 'BICYCLE_RACK',
  BOOSTER_SEAT = 'BOOSTER_SEAT',
  INFANT_SEAT = 'INFANT_SEAT',
  LEFT_HAND_CONTROL = 'LEFT_HAND_CONTROL',
  LUGGAGE_RACK = 'LUGGAGE_RACK',
  NAV_SYSTEM = 'NAV_SYSTEM',
  RIGHT_HAND_CONTROL = 'RIGHT_HAND_CONTROL',
  ROAD_CONGESTION_PAYMENT_SCHEME = 'ROAD_CONGESTION_PAYMENT_SCHEME',
  SATELLITE_RADIO = 'SATELLITE_RADIO',
  SKI_RACK = 'SKI_RACK',
  SNOW_CHAINS = 'SNOW_CHAINS',
  SNOW_TIRES = 'SNOW_TIRES',
  TODDLER_SEAT = 'TODDLER_SEAT',
  TOLL_PAYMENT_TAG_PASS = 'TOLL_PAYMENT_TAG_PASS',
  TRAILER_HITCH = 'TRAILER_HITCH',
  WIFI_ACCESS = 'WIFI_ACCESS',
  WINTER_PACKAGE = 'WINTER_PACKAGE'
}
/** Indicates flight search type */
export enum FlightSearchType {
  MULTI_DESTINATION = 'MULTI_DESTINATION',
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP'
}
/** Supported Features on prepareCheckout */
export enum CheckoutOptionType {
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}

export enum Result {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

export enum CarMembershipProgram {
  AARP = 'AARP',
  AMEX = 'AMEX'
}

export enum FeedbackPlacement {
  FIELD = 'FIELD',
  MODULE = 'MODULE',
  PAGE = 'PAGE'
}

export enum Severity {
  ERROR = 'ERROR',
  WARNING = 'WARNING'
}
/** Ids of inputs that can currently exist as input in special requests */
export enum CheckoutSpecialRequestInputIds {
  ACCESSIBILITY_INPUT = 'ACCESSIBILITY_INPUT',
  BEDDING_INPUT = 'BEDDING_INPUT',
  SMOKING_INPUT = 'SMOKING_INPUT',
  SPECIAL_REQUEST_TEXT = 'SPECIAL_REQUEST_TEXT'
}
/** Types of html element inputs for special requests elements */
export enum CheckoutSpecialRequestInputElementType {
  CHECKBOX = 'CHECKBOX',
  SELECT = 'SELECT',
  TEXTAREA = 'TEXTAREA'
}
/** Types of html elements for special requests */
export enum CheckoutSpecialRequestElementType {
  EXPANDO_LINK = 'EXPANDO_LINK',
  HEADING = 'HEADING'
}

export enum RouteType {
  MULTI_DESTINATION = 'MULTI_DESTINATION',
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP'
}

export enum FlightsFilterType {
  ARRIVAL_AIRPORT = 'ARRIVAL_AIRPORT',
  ARRIVAL_TIME = 'ARRIVAL_TIME',
  DEPARTURE_AIRPORT = 'DEPARTURE_AIRPORT',
  DEPARTURE_TIME = 'DEPARTURE_TIME',
  DURATION = 'DURATION',
  NUM_OF_STOPS = 'NUM_OF_STOPS',
  PREFERRED_AIRLINE = 'PREFERRED_AIRLINE'
}

export enum FlightsFlexibleSearchHeaderCellTheme {
  DEFAULT = 'DEFAULT',
  SEARCHED_DATE_HEADER = 'SEARCHED_DATE_HEADER'
}

export enum FlightsFlexibleSearchLegendCellTheme {
  DEFAULT = 'DEFAULT'
}

export enum FlightsFlexibleSearchResultCellTheme {
  DEFAULT_PRICE = 'DEFAULT_PRICE',
  HIGHEST_PRICE = 'HIGHEST_PRICE',
  LOWEST_PRICE = 'LOWEST_PRICE',
  NO_PRICE = 'NO_PRICE',
  SEARCHED_DATE = 'SEARCHED_DATE',
  SEARCHED_DATE_LOWEST_PRICE = 'SEARCHED_DATE_LOWEST_PRICE',
  SEARCHED_DATE_NO_PRICE = 'SEARCHED_DATE_NO_PRICE',
  SEARCHED_DATE_UNAVAILABLE_FLIGHTS = 'SEARCHED_DATE_UNAVAILABLE_FLIGHTS',
  UNAVAILABLE_FLIGHTS = 'UNAVAILABLE_FLIGHTS'
}

// ====================================================
// END: Typescript template
// ====================================================

// ====================================================
// Documents
// ====================================================

export namespace AddPropertyToCart {
  export type Variables = {
    id: Uuid;
    context: ContextInput;
    propertyOffer: PropertyOfferInput;
    cartPropertySearchContextInput: CartPropertySearchContextInput;
  };

  export type Mutation = {
    __typename?: 'Mutation';

    cartItems: CartItems;
  };

  export type CartItems = {
    __typename?: 'CartMutations';

    addProperty: AddProperty;
  };

  export type AddProperty = {
    __typename?: 'CartSummary';

    id: Uuid;

    itemCount: number;
  };
}

export namespace CreateQuestion {
  export type Variables = {
    context: ContextInput;
    question: string;
    email: string;
    productId: string;
    questioner: string;
    productQuestionTopic: ProductQuestionTopic;
  };

  export type Mutation = {
    __typename?: 'Mutation';

    askProductQuestion?: string | null;
  };
}

export namespace CreateLodgingConversation {
  export type Variables = {
    message: string;
    metadata: LodgingConversationMetadataInput;
  };

  export type Mutation = {
    __typename?: 'Mutation';

    createLodgingConversation?: CreateLodgingConversation | null;
  };

  export type CreateLodgingConversation = {
    __typename?: 'CreateConversationResult';

    result: ConversationsOperationResult;

    action?: string | null;

    alert?: string | null;

    id?: string | null;
  };
}

export namespace CreateMultiItemSession {
  export type Variables = {
    context: ContextInput;
    multiItemSearchContext: MultiItemSearchContextInput;
  };

  export type Mutation = {
    __typename?: 'Mutation';

    createMultiItemSession: CreateMultiItemSession;
  };

  export type CreateMultiItemSession = MultiItemSearchContextCreatedResponseInlineFragment;

  export type MultiItemSearchContextCreatedResponseInlineFragment = {
    __typename?: 'MultiItemSearchContextCreatedResponse';

    shoppingContext: ShoppingContext;
  };

  export type ShoppingContext = {
    __typename?: 'ShoppingContext';

    multiItem?: MultiItem | null;
  };

  export type MultiItem = {
    __typename?: 'MultiItemContext';

    id: string;

    packageType: PackageType;
  };
}

export namespace CreateSessionCart {
  export type Variables = {
    context: ContextInput;
    cartOptions: CartOptionsInput;
  };

  export type Mutation = {
    __typename?: 'Mutation';

    createSessionCart: CreateSessionCart;
  };

  export type CreateSessionCart = {
    __typename?: 'Cart';

    id: Uuid;
  };
}

export namespace Customer {
  export type Variables = {
    context: ContextInput;
    semdtl?: string | null;
  };

  export type Query = {
    __typename?: 'Query';

    customer: Customer;
  };

  export type Customer = {
    __typename?: 'Customer';

    currentTripIntent: CurrentTripIntent;
  };

  export type CurrentTripIntent = {
    __typename?: 'CurrentTripIntent';

    why: Why;
  };

  export type Why = {
    __typename?: 'TripIntentWhy';

    interests: Interests[];
  };

  export type Interests = {
    __typename?: 'Interest';

    name?: string | null;

    desmetId?: string | null;
  };
}

export namespace EmptyCart {
  export type Variables = {
    context: ContextInput;
    id: Uuid;
  };

  export type Mutation = {
    __typename?: 'Mutation';

    cartItems: CartItems;
  };

  export type CartItems = {
    __typename?: 'CartMutations';

    emptyCart: EmptyCart;
  };

  export type EmptyCart = {
    __typename?: 'CartSummary';

    id: Uuid;

    itemCount: number;
  };
}

export namespace Cart {
  export type Variables = {
    context: ContextInput;
    id?: Uuid | null;
  };

  export type Query = {
    __typename?: 'Query';

    cart: Cart;
  };

  export type Cart = {
    __typename?: 'Cart';

    itemCount: number;

    items: Items[];
  };

  export type Items = {
    __typename?: PropertyCartItemInlineFragment['__typename'];

    id: Uuid;
  } & PropertyCartItemInlineFragment;

  export type PropertyCartItemInlineFragment = {
    __typename?: 'PropertyCartItem';

    offers: Offers[];

    summary: Summary;

    gallery: Gallery;
  };

  export type Offers = {
    __typename?: 'PropertyOffer';

    offerIndex: number;

    naturalKeys: NaturalKeys[];

    offer: Offer;
  };

  export type NaturalKeys = {
    __typename?: 'PropertyNaturalKey';

    id: string;

    roomTypeId: string;

    ratePlanId: string;

    checkIn: CheckIn;

    checkOut: CheckOut;

    inventoryType: InventoryType;

    rooms: Rooms[];
  };

  export type CheckIn = {
    __typename?: 'Date';

    isoFormat: string;
  };

  export type CheckOut = {
    __typename?: 'Date';

    isoFormat: string;
  };

  export type Rooms = {
    __typename?: 'PropertyRoom';

    numberOfAdults: number;

    childAges: number[];
  };

  export type Offer = {
    __typename?: 'OfferDetails';

    marketingChannelId?: number | null;

    units: Units[];
  };

  export type Units = {
    __typename?: 'PropertyUnit';

    name?: string | null;

    photos: Photos[];

    ratePlans: RatePlans[];
  };

  export type Photos = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type RatePlans = {
    __typename?: 'RatePlan';

    priceDetails: PriceDetails[];
  };

  export type PriceDetails = {
    __typename?: 'Offer';

    availability?: Availability | null;

    price?: Price | null;

    priceAfterLoyaltyPointsApplied?: PriceAfterLoyaltyPointsApplied | null;

    fees: Fees[];
  };

  export type Availability = {
    __typename?: 'PropertyAvailability';

    available: boolean;

    minRoomsLeft?: number | null;
  };

  export type Price = {
    __typename?: 'PropertyPrice';

    total?: Total | null;

    lead?: Lead | null;
  };

  export type Total = {
    __typename?: 'Money';

    currency: Currency;

    formatted: string;

    raw: number;
  };

  export type Currency = {
    __typename?: 'Currency';

    code: string;

    name: string;

    symbol: string;
  };

  export type Lead = {
    __typename?: 'Money';

    currency: _Currency;

    formatted: string;

    raw: number;
  };

  export type _Currency = {
    __typename?: 'Currency';

    code: string;

    name: string;

    symbol: string;
  };

  export type PriceAfterLoyaltyPointsApplied = {
    __typename?: 'PropertyPrice';

    total?: _Total | null;

    lead?: _Lead | null;
  };

  export type _Total = {
    __typename?: 'Money';

    currency: __Currency;

    formatted: string;

    raw: number;
  };

  export type __Currency = {
    __typename?: 'Currency';

    code: string;

    name: string;

    symbol: string;
  };

  export type _Lead = {
    __typename?: 'Money';

    currency: ___Currency;

    formatted: string;

    raw: number;
  };

  export type ___Currency = {
    __typename?: 'Currency';

    code: string;

    name: string;

    symbol: string;
  };

  export type Fees = {
    __typename?: 'Fees';

    description?: string | null;
  };

  export type Summary = {
    __typename?: 'PropertySummary';

    name: string;

    location?: Location | null;
  };

  export type Location = {
    __typename?: 'PropertyLocation';

    address?: Address | null;
  };

  export type Address = {
    __typename?: 'PropertyAddress';

    city?: string | null;
  };

  export type Gallery = {
    __typename?: 'PropertyGallery';

    featured?: Featured | null;
  };

  export type Featured = {
    __typename?: 'Image';

    url: Url;
  };
}

export namespace Conversations {
  export type Variables = {
    propertyId: string;
  };

  export type Query = {
    __typename?: 'Query';

    lodgingConversations?: LodgingConversations | null;
  };

  export type LodgingConversations = {
    __typename?: 'Conversations';

    newConversation?: NewConversation | null;
  };

  export type NewConversation = {
    __typename?: 'NewConversation';

    form: Form;

    title: string;
  };

  export type Form = {
    __typename?: 'ConversationForm';

    actionText: string;

    comment: Comment;

    emailAddress: EmailAddress;

    name: Name;

    resultText: string;
  };

  export type Comment = {
    __typename?: 'ConversationFormField';

    label: string;

    placeholder?: string | null;

    invalid?: string | null;

    required?: boolean | null;
  };

  export type EmailAddress = {
    __typename?: 'ConversationFormField';

    label: string;

    placeholder?: string | null;

    invalid?: string | null;

    required?: boolean | null;
  };

  export type Name = {
    __typename?: 'ConversationFormField';

    label: string;

    placeholder?: string | null;

    invalid?: string | null;

    required?: boolean | null;
  };
}

export namespace FindAnswersSearch {
  export type Variables = {
    context: ContextInput;
    propertyId: string;
    reviewPagination: PaginationInput;
    reviewSortBy: PropertyReviewSort;
    reviewFilters: PropertyReviewFiltersInput;
    questionFilters: ProductQuestionFiltersInput;
    questionPagination: PaginationInput;
    productQuestionTopic: ProductQuestionTopic;
    questionDateFormat: string;
  };

  export type Query = {
    __typename?: 'Query';

    propertyInfo: PropertyInfo;

    productQuestions?: ProductQuestions | null;
  };

  export type PropertyInfo = {
    __typename?: 'PropertyInfo';

    reviewInfo: ReviewInfo;
  };

  export type ReviewInfo = {
    __typename?: 'PropertyReviews';

    summary: Summary;

    reviews: Reviews[];
  };

  export type Summary = {
    __typename?: 'PropertyReviewSummary';

    superlative?: string | null;

    totalCount: TotalCount;

    averageOverallRating: AverageOverallRating;

    cleanliness: Cleanliness;

    serviceAndStaff: ServiceAndStaff;

    amenityScore?: AmenityScore | null;

    hotelCondition: HotelCondition;

    cleanlinessPercent: number;

    serviceAndStaffPercent: number;

    amenityScorePercent?: number | null;

    hotelConditionPercent: number;

    ratingCounts?: RatingCounts[] | null;

    lastIndex: number;
  };

  export type TotalCount = {
    __typename?: 'FormattedNumber';

    raw: number;

    formatted: string;
  };

  export type AverageOverallRating = {
    __typename?: 'FormattedNumber';

    raw: number;

    formatted: string;
  };

  export type Cleanliness = {
    __typename?: 'FormattedNumber';

    raw: number;

    formatted: string;
  };

  export type ServiceAndStaff = {
    __typename?: 'FormattedNumber';

    raw: number;

    formatted: string;
  };

  export type AmenityScore = {
    __typename?: 'FormattedNumber';

    raw: number;

    formatted: string;
  };

  export type HotelCondition = {
    __typename?: 'FormattedNumber';

    raw: number;

    formatted: string;
  };

  export type RatingCounts = {
    __typename?: 'PropertyReviewRatingCount';

    count: Count;

    percent: number;

    rating: number;
  };

  export type Count = {
    __typename?: 'FormattedNumber';

    formatted: string;

    raw: number;
  };

  export type Reviews = {
    __typename?: 'PropertyReview';

    id: string;

    ratingOverall: number;

    superlative?: string | null;

    submissionTime: SubmissionTime;

    title: string;

    text: string;

    locale: Locale;

    author?: string | null;

    userLocation: string;

    stayDuration?: string | null;

    helpfulReviewVotes?: string | null;

    negativeRemarks?: string | null;

    positiveRemarks?: string | null;

    locationRemarks?: string | null;

    photos: Photos[];

    managementResponses: ManagementResponses[];

    travelers: string[];

    themes?: Themes[] | null;
  };

  export type SubmissionTime = {
    __typename?: 'DateTime';

    raw: string;
  };

  export type Photos = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type ManagementResponses = {
    __typename?: 'ManagementResponse';

    id?: string | null;

    date?: string | null;

    displayLocale?: string | null;

    userNickname?: string | null;

    response?: string | null;
  };

  export type Themes = {
    __typename?: 'ReviewThemes';

    icon?: Icon | null;

    label?: string | null;
  };

  export type Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type ProductQuestions = {
    __typename?: 'ProductQuestions';

    totalCount?: _TotalCount | null;

    questions: Questions[];
  };

  export type _TotalCount = {
    __typename?: 'FormattedNumber';

    raw: number;
  };

  export type Questions = {
    __typename?: 'UserQuestion';

    answers?: Answers[] | null;

    createDate?: CreateDate | null;

    id: string;

    question: string;

    questioner?: string | null;

    totalAnswers: TotalAnswers;
  };

  export type Answers = {
    __typename?: 'UserAnswer';

    answer: string;

    answerTime: AnswerTime;

    displayName?: string | null;

    id: string;

    upVotes: UpVotes;
  };

  export type AnswerTime = {
    __typename?: 'DateTime';

    formatted: string;

    raw: string;
  };

  export type UpVotes = {
    __typename?: 'FormattedNumber';

    raw: number;
  };

  export type CreateDate = {
    __typename?: 'DateTime';

    formatted: string;

    raw: string;
  };

  export type TotalAnswers = {
    __typename?: 'FormattedNumber';

    raw: number;
  };
}

export namespace PropertyLocationScoreInfo {
  export type Variables = {
    propertyIds: string[];
    context: ContextInput;
  };

  export type Query = {
    __typename?: 'Query';

    propertyReviewAggregates: PropertyReviewAggregates;
  };

  export type PropertyReviewAggregates = {
    __typename?: 'PropertyReviewAggregates';

    propertySummaries?: PropertySummaries[] | null;
  };

  export type PropertySummaries = {
    __typename?: 'LodgingReviewSummary';

    propertyId: string;

    locationScore?: LocationScore | null;
  };

  export type LocationScore = {
    __typename?: 'SummaryUnit';

    score?: string | null;

    tags: Tags[];
  };

  export type Tags = {
    __typename?: 'Tag';

    label: string;
  };
}

export namespace LodgingPwaPropertySearch {
  export type Variables = {
    context: ContextInput;
    destination: DestinationInput;
    rooms?: RoomInput[] | null;
    dateRange?: PropertyDateRangeInput | null;
    sort?: PropertySort | null;
    filters?: PropertySearchFiltersInput | null;
    marketing?: PropertyMarketingInfoInput | null;
    legacyCriteria?: LegacyPropertySearchCriteriaInput | null;
    propertyShopOptions?: PropertyShopOptionsInput | null;
    searchPagination?: PaginationInput | null;
    searchIntent?: SearchIntentInput | null;
    shoppingContext?: ShoppingContextInput | null;
  };

  export type Query = {
    __typename?: 'Query';

    propertySearch: PropertySearch;
  };

  export type PropertySearch = {
    __typename?: 'PropertySearchResults';

    searchCriteria: SearchCriteria;

    sortAndFilter: SortAndFilter;

    properties: Properties[];

    summary: Summary;

    map?: Map | null;

    exitIntent?: ExitIntent | null;

    lodgingIntentMedia?: LodgingIntentMedia | null;

    shoppingContext?: ShoppingContext | null;

    multiItemSearchContext?: MultiItemSearchContext | null;
  };

  export type SearchCriteria = {
    __typename?: 'SearchCriteria';

    propertyShopOptions?: PropertyShopOptions | null;

    dateRange: DateRange;

    destination: Destination;

    searchIntent?: SearchIntent | null;

    sort?: PropertySort | null;

    filters?: Filters | null;
  };

  export type PropertyShopOptions = {
    __typename?: 'PropertyShopOptions';

    points?: Points | null;
  };

  export type DateRange = {
    __typename?: 'PropertyDateRange';

    checkInDate: CheckInDate;

    checkOutDate: CheckOutDate;
  };

  export type CheckInDate = CommonDateFields.Fragment;

  export type CheckOutDate = CommonDateFields.Fragment;

  export type Destination = {
    __typename?: 'Destination';

    regionId?: string | null;

    regionName?: string | null;
  };

  export type SearchIntent = {
    __typename?: 'SearchIntent';

    theme?: string | null;

    userIntent?: string | null;

    semdtl?: string | null;
  };

  export type Filters = {
    __typename?: 'PropertySearchFilters';

    accessibility?: PropertyFilterAccessibility[] | null;

    amenities?: PropertyFilterAmenity[] | null;

    bedroomFilter?: number[] | null;

    commissionTiers?: CommissionTier[] | null;

    agencyBusinessModels?: AgencyBusinessModel[] | null;

    deals?: DealType[] | null;

    paymentType?: PaymentType[] | null;

    poi?: string | null;

    priceBuckets?: number[] | null;

    propertyName?: string | null;

    propertyStyles?: PropertyStyle[] | null;

    reviewScore?: ReviewScore | null;

    starList?: number[] | null;

    structureTypes?: StructureType[] | null;

    travelerType?: TravelerType[] | null;

    mealPlan?: MealPlanFilterAmenity[] | null;
  };

  export type ReviewScore = {
    __typename?: 'ReviewScoreRange';

    min?: number | null;

    max?: number | null;
  };

  export type SortAndFilter = {
    __typename?: 'SortAndFilter';

    defaults?: Defaults | null;

    selected?: Selected | null;

    options?: Options | null;
  };

  export type Defaults = {
    __typename?: 'SortAndFilterDefaults';

    sort: PropertySort;

    regionId?: string | null;
  };

  export type Selected = {
    __typename?: 'SortAndFilterSelected';

    priceFilterPills?: PriceFilterPills | null;

    star?: string | null;
  };

  export type PriceFilterPills = {
    __typename?: 'PriceFilterPills';

    aggregate?: Aggregate | null;

    buckets?: number[] | null;
  };

  export type Aggregate = {
    __typename?: 'PriceFilterPillsAggregate';

    label?: string | null;

    value?: string | null;
  };

  export type Options = {
    __typename?: 'SortAndFilterViewModel';

    appliedFilterCount: number;

    sortAndFilter: _SortAndFilter[];
  };

  export type _SortAndFilter = {
    __typename?: 'FilterViewModel';

    selected: boolean;

    isRange?: boolean | null;

    label?: string | null;

    max?: number | null;

    min?: number | null;

    name: string;

    placeholder?: string | null;

    step?: number | null;

    subLabel?: string | null;

    hiddenThreshold?: number | null;

    options: _Options[];
  };

  export type _Options = {
    __typename?: 'OptionViewModel';

    selectedLabel?: string | null;

    ariaLabel?: string | null;

    description?: string | null;

    icon?: string | null;

    isSelected: boolean;

    label?: string | null;

    value?: string | null;

    optionValue?: string | null;

    range?: Range | null;

    filterCategory?: string | null;
  };

  export type Range = {
    __typename?: 'FilterOptionRange';

    min?: number | null;

    max?: number | null;
  };

  export type Properties = {
    __typename?: 'Property';

    star?: number | null;

    starRatingIcon: string;

    availability: Availability;

    offerSummary: OfferSummary;

    legalDisclaimer?: LegalDisclaimer | null;

    lodgingPriceBreakDown?: LodgingPriceBreakDown | null;

    gallery?: Gallery[] | null;

    propertyGallery?: PropertyGallery[] | null;

    mapMarker?: MapMarker | null;

    neighborhood?: Neighborhood | null;

    offerBadge?: OfferBadge | null;

    pinnedDetails?: PinnedDetails | null;

    recentlyViewed?: RecentlyViewed | null;

    supportingMessages?: string[] | null;

    shortList?: ShortList | null;

    sponsoredListing?: SponsoredListing | null;

    highlightedPropertyDetail?: string | null;

    dataAttributes?: DataAttributes | null;

    listingFooter?: ListingFooter | null;
  } & CommonPropertyCardFields.Fragment;

  export type Availability = {
    __typename?: 'PropertyAvailability';

    available: boolean;

    text?: string | null;

    theme?: Theme | null;
  };

  export type OfferSummary = {
    __typename?: 'OfferSummary';

    messages?: Messages[] | null;
  };

  export type Messages = {
    __typename?: 'OfferSummaryMessage';

    message?: string | null;

    theme?: Theme | null;

    type?: string | null;
  };

  export type LegalDisclaimer = {
    __typename?: 'PropertyLegalDisclaimer';

    title?: string | null;

    disclaimerContents?: string[] | null;
  };

  export type LodgingPriceBreakDown = {
    __typename?: 'LodgingPriceBreakDown';

    header: string;

    priceBreakDownEntries?: PriceBreakDownEntries[] | null;

    footer?: Footer | null;

    unbundledEntries?: UnbundledEntries[] | null;

    ctaLabel?: string | null;
  };

  export type PriceBreakDownEntries = {
    __typename?: 'LodgingPriceBreakDownEntry';

    amount?: string | null;

    description?: string | null;

    detail?: string | null;
  };

  export type Footer = {
    __typename?: 'LodgingPriceBreakDownEntry';

    amount?: string | null;

    description?: string | null;

    detail?: string | null;
  };

  export type UnbundledEntries = {
    __typename?: 'LodgingPriceBreakDownEntry';

    amount?: string | null;

    description?: string | null;

    detail?: string | null;
  };

  export type Gallery = {
    __typename?: 'Image';

    url: Url;

    description: string;
  };

  export type PropertyGallery = {
    __typename?: 'PropertyImage';

    image: Image;

    subjectId?: number | null;

    fallbackImage?: FallbackImage | null;
  };

  export type Image = {
    __typename?: 'Image';

    url: Url;

    description: string;
  };

  export type FallbackImage = {
    __typename?: 'Image';

    url: Url;

    description: string;
  };

  export type MapMarker = {
    __typename?: 'MapMarker';

    icon: MapIconType;

    label: string;

    type?: MarkerType | null;

    latLong: LatLong;
  };

  export type LatLong = {
    __typename?: 'Coordinates';

    latitude: number;

    longitude: number;
  };

  export type Neighborhood = {
    __typename?: 'Region';

    name: string;
  };

  export type OfferBadge = {
    __typename?: 'OfferBadge';

    primary?: Primary | null;

    secondary?: Secondary | null;
  };

  export type Primary = {
    __typename?: 'Badge';

    text?: string | null;

    theme_temp?: Theme | null;

    icon_temp?: IconTemp | null;
  };

  export type IconTemp = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type Secondary = {
    __typename?: 'Badge';

    text?: string | null;

    theme_temp?: Theme | null;

    icon_temp?: _IconTemp | null;
  };

  export type _IconTemp = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type PinnedDetails = {
    __typename?: 'PinnedPropertyModel';

    heading: string;
  };

  export type RecentlyViewed = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type ShortList = {
    __typename?: 'ShortList';

    favorited: boolean;

    saveUrl: string;

    removeUrl: string;

    metaData: MetaData;

    clickTracking: ClickTracking[];
  };

  export type MetaData = {
    __typename?: 'ShortListMetaData';

    chkIn: string;

    chkOut: string;

    hotelId: string;

    roomConfiguration: string;
  };

  export type ClickTracking = ShoppingGlobalDataInlineFragment | AllHotelProductsDataInlineFragment;

  export type ShoppingGlobalDataInlineFragment = {
    __typename?: 'ShoppingGlobalData';

    schemaName: string;

    messageContent: MessageContent;
  };

  export type MessageContent = {
    __typename?: 'ShoppingGlobal';

    destinationCode: string;

    destinationName?: string | null;

    numAdults?: number | null;

    numChildren?: number | null;

    shoppingHotel: ShoppingHotel;

    tripEndDate?: string | null;

    tripStartDate?: string | null;
  };

  export type ShoppingHotel = {
    __typename?: 'ShoppingHotel';

    numRooms: number;

    rooms: Rooms[];
  };

  export type Rooms = {
    __typename?: 'Rooms';

    childrenAges?: number[] | null;

    numAdults: number;

    numChildren?: number | null;
  };

  export type AllHotelProductsDataInlineFragment = {
    __typename?: 'AllHotelProductsData';

    schemaName: string;

    messageContent: _MessageContent;
  };

  export type _MessageContent = {
    __typename?: 'AllHotelProducts';

    hotelProducts: HotelProducts[];
  };

  export type HotelProducts = {
    __typename?: 'HotelProduct';

    productId: number;

    productType?: string | null;
  };

  export type SponsoredListing = {
    __typename?: 'SponsoredListing';

    id?: string | null;

    clickRedirectTrackingUrl?: Url | null;

    clickTrackingUrl?: Url | null;

    details?: string | null;

    detailsHeadline?: string | null;

    hotelImage?: string | null;

    impressionTrackingUrl?: Url | null;

    trackingData?: string | null;

    brand?: string | null;

    clickRedirectLinkoffTrackingUrl?: Url | null;

    logo?: string | null;

    lotagline?: string | null;

    rating?: string | null;

    slots?: string | null;

    vanityUrl?: Url | null;

    rank?: string | null;

    position?: string | null;
  };

  export type DataAttributes = {
    __typename?: 'GraphQLPair';

    key: string;

    value: string;
  };

  export type ListingFooter = {
    __typename?: 'MessagingAction';

    actionDetails?: ActionDetails | null;

    icon?: Icon | null;

    linkUrl: string;

    referrerId?: string | null;

    text?: string | null;
  };

  export type ActionDetails = {
    __typename?: 'ActionDetails';

    name: ActionDetailsType;
  };

  export type Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };

  export type Summary = {
    __typename?: 'PropertyResultsSummary';

    resultsSummary?: ResultsSummary[] | null;

    pricedHotelSize: number;

    region?: Region | null;

    resultSectionHeadings?: ResultSectionHeadings[] | null;

    messages?: _Messages[] | null;

    loyaltyEducation?: LoyaltyEducation | null;

    loyaltyInfo?: LoyaltyInfo | null;

    matchedPropertiesSize: number;

    resultsHeading?: string | null;
  };

  export type ResultsSummary = {
    __typename?: LodgingLinkMessageInlineFragment['__typename'] | LodgingDialogTriggerMessageInlineFragment['__typename'];

    value: string;
  } & (LodgingLinkMessageInlineFragment | LodgingDialogTriggerMessageInlineFragment);

  export type LodgingLinkMessageInlineFragment = SearchLinkMessage.Fragment;

  export type LodgingDialogTriggerMessageInlineFragment = SearchDialogMessage.Fragment;

  export type Region = {
    __typename?: 'Region';

    name: string;

    id: string;
  };

  export type ResultSectionHeadings = {
    __typename?: 'ResultSectionHeading';

    heading: string;

    index: number;
  };

  export type _Messages = {
    __typename?: 'MessageResult';

    title?: Title | null;

    subtitle?: Subtitle | null;

    action?: Action | null;

    index?: number | null;

    type?: MessageType | null;
  };

  export type Title = {
    __typename?: 'MessagingResultTitle';

    text?: string | null;

    icon?: _Icon | null;

    theme?: Theme | null;
  };

  export type _Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };

  export type Subtitle = {
    __typename?: 'MessagingResultTitle';

    text?: string | null;

    icon?: __Icon | null;

    theme?: Theme | null;
  };

  export type __Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };

  export type Action = {
    __typename?: 'MessagingResultAction';

    primary?: _Primary | null;

    secondary?: _Secondary | null;
  };

  export type _Primary = {
    __typename?: 'MessagingAction';

    text?: string | null;

    linkUrl: string;

    referrerId?: string | null;

    actionDetails?: _ActionDetails | null;
  };

  export type _ActionDetails = {
    __typename?: 'ActionDetails';

    name: ActionDetailsType;

    details?: string | null;
  };

  export type _Secondary = {
    __typename?: 'MessagingAction';

    text?: string | null;

    linkUrl: string;

    referrerId?: string | null;

    actionDetails?: __ActionDetails | null;
  };

  export type __ActionDetails = {
    __typename?: 'ActionDetails';

    name: ActionDetailsType;

    details?: string | null;
  };

  export type LoyaltyEducation = {
    __typename?: 'LoyaltyEducation';

    action?: _Action | null;

    content: Content;

    title?: string | null;
  };

  export type _Action = {
    __typename?: 'LoyaltyEducationAction';

    href?: string | null;

    rfrr?: string | null;

    text?: string | null;
  };

  export type Content = PointsEducationFragment.Fragment | ProgramEducationFragment.Fragment;

  export type LoyaltyInfo = {
    __typename?: 'PropertyLoyaltyDiscount';

    pointsAppliedMessage?: string | null;

    saveWithPointsMessage?: string | null;

    saveWithPointsActionMessage?: string | null;
  };

  export type Map = {
    __typename?: 'PropertySearchMap';

    bounds: Bounds;

    center: Center;

    markers: Markers[];

    staticMapSrc?: string | null;

    title: string;

    subtitle?: string | null;

    zoom: number;

    messagingModel?: MessagingModel | null;
  };

  export type Bounds = {
    __typename?: 'Bounds';

    northeast: Northeast;

    southwest: Southwest;
  };

  export type Northeast = {
    __typename?: 'Coordinates';

    latitude: number;

    longitude: number;
  };

  export type Southwest = {
    __typename?: 'Coordinates';

    latitude: number;

    longitude: number;
  };

  export type Center = {
    __typename?: 'Coordinates';

    latitude: number;

    longitude: number;
  };

  export type Markers = {
    __typename?: PropertyInlineFragment['__typename'] | PointOfInterestInlineFragment['__typename'];

    mapMarker?: _MapMarker | null;
  } & (PropertyInlineFragment | PointOfInterestInlineFragment);

  export type _MapMarker = {
    __typename?: 'MapMarker';

    label: string;

    icon: MapIconType;

    type?: MarkerType | null;

    latLong: _LatLong;
  };

  export type _LatLong = {
    __typename?: 'Coordinates';

    latitude: number;

    longitude: number;
  };

  export type PropertyInlineFragment = CommonPropertyCardFields.Fragment;

  export type PointOfInterestInlineFragment = {
    __typename?: 'PointOfInterest';

    name: string;
  };

  export type MessagingModel = {
    __typename?: 'MessageResult';

    title?: _Title | null;

    subtitle?: _Subtitle | null;

    type?: MessageType | null;
  };

  export type _Title = {
    __typename?: 'MessagingResultTitle';

    text?: string | null;

    theme?: Theme | null;

    icon?: ___Icon | null;
  };

  export type ___Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };

  export type _Subtitle = {
    __typename?: 'MessagingResultTitle';

    text?: string | null;

    theme?: Theme | null;

    icon?: ____Icon | null;
  };

  export type ____Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };

  export type ExitIntent = {
    __typename?: 'ExitIntent';

    logoUrl?: string | null;

    backgroundImageUrl?: string | null;

    clickHereLinkUrl?: string | null;

    message: Message;
  };

  export type Message = {
    __typename?: 'ExitIntentMessage';

    headingOne?: string | null;

    headingTwo?: string | null;

    headingThree?: string | null;

    couponCode?: string | null;

    percentOff?: string | null;

    termsAndConditionsOne?: string | null;

    termsAndConditionsTwo?: string | null;

    clickHere?: string | null;
  };

  export type LodgingIntentMedia = {
    __typename?: 'LodgingIntentMedia';

    city: string;

    countryCode: string;

    machineId: string;

    machineIdHashed: string;

    publisherSessionId: string;

    publisherSessionIdHashed: string;

    publisherUserIdHashed: string;

    referrerChannel: string;

    referrerSource: string;

    state: string;
  };

  export type ShoppingContext = {
    __typename?: 'ShoppingContext';

    multiItem?: MultiItem | null;
  };

  export type MultiItem = {
    __typename?: 'MultiItemContext';

    id: string;
  };

  export type MultiItemSearchContext = {
    __typename?: 'MultiItemSearchContext';

    properties?: _Properties[] | null;

    cars?: Cars[] | null;
  };

  export type _Properties = {
    __typename?: 'PropertySearchCriteria';

    primary: __Primary;
  };

  export type __Primary = {
    __typename?: 'PrimaryPropertyCriteria';

    rooms: _Rooms[];

    destination: _Destination;

    dateRange?: _DateRange | null;
  };

  export type _Rooms = {
    __typename?: 'Room';

    adults: number;
  };

  export type _Destination = {
    __typename?: 'Destination';

    regionId?: string | null;

    regionName?: string | null;
  };

  export type _DateRange = {
    __typename?: 'PropertyDateRange';

    checkInDate: _CheckInDate;

    checkOutDate: _CheckOutDate;
  };

  export type _CheckInDate = CommonDateFields.Fragment;

  export type _CheckOutDate = CommonDateFields.Fragment;

  export type Cars = {
    __typename?: 'CarSearchCriteria';

    primary: ___Primary;
  };

  export type ___Primary = {
    __typename?: 'PrimaryCarCriteria';

    pickUpDateTime: PickUpDateTime;

    dropOffDateTime: DropOffDateTime;

    pickUpLocation: PickUpLocation;

    dropOffLocation?: DropOffLocation | null;
  };

  export type PickUpDateTime = CommonDateTimeFields.Fragment;

  export type DropOffDateTime = CommonDateTimeFields.Fragment;

  export type PickUpLocation = {
    __typename?: 'CarRentalLocation';

    airportCode?: string | null;
  };

  export type DropOffLocation = {
    __typename?: 'CarRentalLocation';

    airportCode?: string | null;
  };
}

export namespace PrepareCheckoutByCartId {
  export type Variables = {
    context: ContextInput;
    id: Uuid;
    totalPrice: MoneyInput;
    marketingChannelId?: number | null;
  };

  export type Mutation = {
    __typename?: 'Mutation';

    prepareCheckoutByCartId: PrepareCheckoutByCartId;
  };

  export type PrepareCheckoutByCartId = {
    __typename?: 'PrepareCheckoutResponse';

    tripId?: Uuid | null;

    checkoutUrl?: Url | null;

    failureReason?: FailureReason | null;
  };

  export type FailureReason = MaxRoomsFailureInlineFragment;

  export type MaxRoomsFailureInlineFragment = {
    __typename?: 'MaxRoomsFailure';

    groupLinkMessage?: string | null;

    message?: string | null;
  };
}

export namespace PrepareCheckout {
  export type Variables = {
    context: ContextInput;
    properties?: PropertyNaturalKeyInput[] | null;
    cookies: string;
  };

  export type Mutation = {
    __typename?: 'Mutation';

    prepareCheckout: PrepareCheckout;
  };

  export type PrepareCheckout = {
    __typename?: 'PrepareCheckoutResponse';

    tripId?: Uuid | null;

    checkoutUrl?: Url | null;
  };
}

export namespace PropertyInfoDetails {
  export type Variables = {
    context: ContextInput;
    propertyId: string;
    requestContext: BffRequestContextInput;
  };

  export type Query = {
    __typename?: 'Query';

    propertyInfo: PropertyInfo;
  };

  export type PropertyInfo = {
    __typename?: 'PropertyInfo';

    propertyGallery?: PropertyGallery | null;

    pwaOnlyBffResponse: PwaOnlyBffResponse;

    summary?: Summary | null;

    intentMedia?: IntentMedia | null;

    feedback: Feedback;
  };

  export type PropertyGallery = {
    __typename?: 'PropertyImageGallery';

    images: Images[];

    categories?: Categories[] | null;
  };

  export type Images = {
    __typename?: 'PropertyImage';

    alt?: string | null;

    image: Image;

    thumbnail?: Thumbnail | null;

    fallbackImage?: FallbackImage | null;

    subjectId?: number | null;
  };

  export type Image = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type Thumbnail = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type FallbackImage = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type Categories = {
    __typename?: 'PropertyGalleryCategory';

    id: string;

    name: string;

    images: _Images[];
  };

  export type _Images = {
    __typename?: 'PropertyImage';

    alt?: string | null;

    image: _Image;

    thumbnail?: _Thumbnail | null;

    fallbackImage?: _FallbackImage | null;

    subjectId?: number | null;
  };

  export type _Image = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type _Thumbnail = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type _FallbackImage = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type PwaOnlyBffResponse = {
    __typename?: 'BffResponse';

    details: string;
  };

  export type Summary = {
    __typename?: 'PropertySummary';

    name: string;

    nearbyPOIs?: NearbyPoIs | null;

    location?: Location | null;

    overview?: Overview | null;

    starRatingIcon?: StarRatingIcon | null;

    telesalesPhoneNumber: string;

    propertyTypeBadge?: string | null;

    amenities?: Amenities | null;

    map?: Map | null;

    navigationBarTabs?: NavigationBarTabs[] | null;
  };

  export type NearbyPoIs = {
    __typename?: 'PropertyInfoContent';

    title: string;

    items: Items[];
  };

  export type Items = {
    __typename?: 'PropertyInfoItem';

    text: string;

    moreInfo?: string | null;

    icon?: Icon | null;
  };

  export type Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type Location = {
    __typename?: 'PropertyLocation';

    address?: Address | null;

    coordinates?: Coordinates | null;

    overviewStaticMapSrc?: string | null;

    whatsAround?: WhatsAround | null;
  };

  export type Address = {
    __typename?: 'PropertyAddress';

    addressLine?: string | null;

    city?: string | null;

    countryCode?: string | null;

    firstAddressLine?: string | null;

    province?: string | null;
  };

  export type Coordinates = {
    __typename?: 'Coordinates';

    latitude: number;

    longitude: number;
  };

  export type WhatsAround = {
    __typename?: 'PropertyWhatsAround';

    title: string;

    editorial?: Editorial | null;

    nearbyPOIs: _NearbyPoIs[];

    staticMapSrc?: string | null;
  };

  export type Editorial = {
    __typename?: 'PropertyEditorial';

    content: string[];

    crossLink?: CrossLink | null;

    title: string;
  };

  export type CrossLink = {
    __typename?: 'LodgingLinkMessage';

    link: Link;

    value: string;
  };

  export type Link = {
    __typename?: 'LodgingLink';

    url: Url;
  };

  export type _NearbyPoIs = {
    __typename?: 'PropertyInfoContent';

    items: _Items[];

    title: string;

    icon?: __Icon | null;
  };

  export type _Items = {
    __typename?: 'PropertyInfoItem';

    text: string;

    moreInfo?: string | null;

    icon?: _Icon | null;
  };

  export type _Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type __Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type Overview = {
    __typename?: 'PropertyOverview';

    starRating?: number | null;

    vipMessaging?: string | null;
  };

  export type StarRatingIcon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };

  export type Amenities = {
    __typename?: 'PropertyAmenities';

    amenities: _Amenities[];

    takeover?: Takeover | null;

    top: Top[];
  };

  export type _Amenities = {
    __typename?: 'PropertyInfoSection';

    title?: string | null;

    contents: Contents[];
  };

  export type Contents = {
    __typename?: 'PropertyInfoContent';

    heading?: string | null;

    icon?: ___Icon | null;

    items: __Items[];
  };

  export type ___Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type __Items = {
    __typename?: 'PropertyInfoItem';

    text: string;
  };

  export type Takeover = {
    __typename?: 'PropertyTakeoverAmenities';

    highlight: Highlight[];
  };

  export type Highlight = {
    __typename?: 'PropertyInfoContent';

    heading?: string | null;

    items: ___Items[];
  };

  export type ___Items = {
    __typename?: 'PropertyInfoItem';

    text: string;

    icon?: ____Icon | null;
  };

  export type ____Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type Top = {
    __typename?: 'PropertyInfoItem';

    icon?: _____Icon | null;

    text: string;
  };

  export type _____Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type Map = {
    __typename?: 'PropertyInfoMap';

    bounds?: Bounds | null;

    center?: Center | null;

    markers?: Markers[] | null;

    staticMapSrc?: string | null;

    title?: string | null;

    zoom?: number | null;
  };

  export type Bounds = {
    __typename?: 'Bounds';

    northeast: Northeast;

    southwest: Southwest;
  };

  export type Northeast = {
    __typename?: 'Coordinates';

    latitude: number;

    longitude: number;
  };

  export type Southwest = {
    __typename?: 'Coordinates';

    latitude: number;

    longitude: number;
  };

  export type Center = {
    __typename?: 'Coordinates';

    latitude: number;

    longitude: number;
  };

  export type Markers = PointOfInterestInlineFragment;

  export type PointOfInterestInlineFragment = {
    __typename?: 'PointOfInterest';

    id?: string | null;

    title: string;

    subtitle?: string | null;

    mapMarker: MapMarker;
  };

  export type MapMarker = {
    __typename?: 'MapMarker';

    icon: MapIconType;

    latLong: LatLong;
  };

  export type LatLong = {
    __typename?: 'Coordinates';

    latitude: number;

    longitude: number;
  };

  export type NavigationBarTabs = {
    __typename?: 'PropertyNavigationBarTab';

    sectionName: string;

    localizedName: string;
  };

  export type IntentMedia = {
    __typename?: 'LodgingIntentMedia';

    city: string;

    countryCode: string;

    machineId: string;

    machineIdHashed: string;

    publisherSessionId: string;

    publisherSessionIdHashed: string;

    publisherUserIdHashed: string;

    referrerChannel: string;

    referrerSource: string;

    state: string;
  };

  export type Feedback = {
    __typename?: 'Feedback';

    action?: Action | null;
  };

  export type Action = {
    __typename?: 'FeedbackAction';

    text?: string | null;
  };
}

export namespace PropertyInfoOffersBase {
  export type Variables = {
    context: ContextInput;
    propertyId: string;
    requestContext: BffRequestContextInput;
  };

  export type Query = {
    __typename?: 'Query';

    propertyInfo: PropertyInfo;
  };

  export type PropertyInfo = {
    __typename?: 'PropertyInfo';

    pwaOnlyBffResponse: PwaOnlyBffResponse;
  };

  export type PwaOnlyBffResponse = {
    __typename?: 'BffResponse';

    offers: string;
  };
}

export namespace PropertyInfoOffersBexFeatures {
  export type Variables = {
    context: ContextInput;
    propertyId: string;
    requestContext: BffRequestContextInput;
    dateRange: PropertyDateRangeInput;
    roomInput: RoomInput[];
  };

  export type Query = {
    __typename?: 'Query';

    propertyInfo: PropertyInfo;
  };

  export type PropertyInfo = {
    __typename?: 'PropertyInfo';

    pwaOnlyBffResponse: PwaOnlyBffResponse;

    offers?: Offers | null;
  };

  export type PwaOnlyBffResponse = {
    __typename?: 'BffResponse';

    offers: string;
  };

  export type Offers = {
    __typename?: 'OfferDetails';

    units: Units[];

    paymentPolicy: PaymentPolicy[];
  };

  export type Units = {
    __typename?: 'PropertyUnit';

    bookingUrl?: string | null;

    bedOptions: BedOptions[];

    description?: string | null;

    id: string;

    name?: string | null;

    header?: Header | null;

    size?: string | null;

    ratePlansExpando: RatePlansExpando;

    features: Features[];

    gallery: Gallery[];
  };

  export type BedOptions = {
    __typename?: 'BedOptions';

    name: string;

    icon: string;
  };

  export type Header = {
    __typename?: 'LodgingHeader';

    icon?: Icon | null;

    text?: string | null;

    subText?: string | null;
  };

  export type Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type RatePlansExpando = {
    __typename?: 'RatePlansExpando';

    expandButton: ExpandButton;
  };

  export type ExpandButton = {
    __typename?: 'LodgingButton';

    text: string;
  };

  export type Features = {
    __typename?: 'PropertyInfoItem';

    text: string;

    moreInfo?: string | null;

    icon?: _Icon | null;
  };

  export type _Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type Gallery = {
    __typename?: 'PropertyImage';

    alt?: string | null;

    image: Image;

    thumbnail?: Thumbnail | null;

    fallbackImage?: FallbackImage | null;

    subjectId?: number | null;
  };

  export type Image = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type Thumbnail = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type FallbackImage = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type PaymentPolicy = {
    __typename?: 'PropertyPaymentPolicyInfo';

    paymentType: PropertyPaymentType;

    text: string[];
  };
}

export namespace PropertyRoomScoreInfo {
  export type Variables = {
    propertyIds: string[];
    context: ContextInput;
  };

  export type Query = {
    __typename?: 'Query';

    propertyReviewAggregates: PropertyReviewAggregates;
  };

  export type PropertyReviewAggregates = {
    __typename?: 'PropertyReviewAggregates';

    propertySummaries?: PropertySummaries[] | null;
  };

  export type PropertySummaries = {
    __typename?: 'LodgingReviewSummary';

    propertyId: string;

    roomsScore?: RoomsScore[] | null;
  };

  export type RoomsScore = {
    __typename?: 'RoomSummary';

    id: string;

    score?: string | null;

    tags: Tags[];
  };

  export type Tags = {
    __typename?: 'Tag';

    label: string;
  };
}

export namespace PropertyKeyPhrases {
  export type Variables = {
    propertyIds: string[];
    context: ContextInput;
    limit?: number | null;
    client?: KeyPhrasesClientType | null;
  };

  export type Query = {
    __typename?: 'Query';

    propertyReviewAggregates: PropertyReviewAggregates;
  };

  export type PropertyReviewAggregates = {
    __typename?: 'PropertyReviewAggregates';

    popularMentions?: PopularMentions | null;
  };

  export type PopularMentions = {
    __typename?: 'KeyPhrasesComponent';

    label?: string | null;

    phrases?: Phrases[] | null;
  };

  export type Phrases = {
    __typename?: 'KeyPhrase';

    text?: string | null;
  };
}

export namespace PropertyPoiContent {
  export type Variables = {
    context: ContextInput;
    poiIDs: string;
  };

  export type Query = {
    __typename?: 'Query';

    propertyPoiContent?: PropertyPoiContent[] | null;
  };

  export type PropertyPoiContent = {
    __typename?: 'PoiContent';

    description?: string | null;

    id: string;

    image?: Image | null;
  };

  export type Image = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };
}

export namespace PropertySearchTravelAds {
  export type Variables = {
    context: ContextInput;
    destination: DestinationInput;
    rooms?: RoomInput[] | null;
    dateRange?: PropertyDateRangeInput | null;
    sort?: PropertySort | null;
    filters?: PropertySearchFiltersInput | null;
    marketing?: PropertyMarketingInfoInput | null;
    legacyCriteria?: LegacyPropertySearchCriteriaInput | null;
    propertyShopOptions?: PropertyShopOptionsInput | null;
    searchPagination?: PaginationInput | null;
    searchIntent?: SearchIntentInput | null;
    shoppingContext?: ShoppingContextInput | null;
  };

  export type Query = {
    __typename?: 'Query';

    propertySearch: PropertySearch;
  };

  export type PropertySearch = {
    __typename?: 'PropertySearchResults';

    properties: Properties[];
  };

  export type Properties = {
    __typename?: 'Property';

    id: string;

    name: string;

    propertyImage?: PropertyImage | null;

    offerBadge?: OfferBadge | null;

    price?: Price | null;

    reviews: Reviews;

    destinationInfo: DestinationInfo;

    vipMessaging?: string | null;

    infositeURL: string;

    star?: number | null;

    starRatingIcon: string;

    availability: Availability;

    offerSummary: OfferSummary;

    legalDisclaimer?: LegalDisclaimer | null;

    neighborhood?: Neighborhood | null;

    recentlyViewed?: RecentlyViewed | null;

    supportingMessages?: string[] | null;

    shortList?: ShortList | null;

    sponsoredListing?: SponsoredListing | null;

    highlightedPropertyDetail?: string | null;

    dataAttributes?: DataAttributes | null;
  };

  export type PropertyImage = {
    __typename?: 'PropertyImage';

    image: Image;
  };

  export type Image = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type OfferBadge = {
    __typename?: 'OfferBadge';

    primary?: Primary | null;

    secondary?: Secondary | null;
  };

  export type Primary = {
    __typename?: 'Badge';

    text?: string | null;

    theme_temp?: Theme | null;

    icon_temp?: IconTemp | null;
  };

  export type IconTemp = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type Secondary = {
    __typename?: 'Badge';

    text?: string | null;

    theme_temp?: Theme | null;

    icon_temp?: _IconTemp | null;
  };

  export type _IconTemp = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type Price = {
    __typename?: 'PropertyPrice';

    lead?: Lead | null;

    strikeOutType?: StrikeOutType | null;

    strikeOut?: StrikeOut | null;

    disclaimer?: Disclaimer | null;

    roomNightMessage?: string | null;

    priceMessages?: PriceMessages[] | null;

    marketingFeeDetails?: MarketingFeeDetails | null;

    options?: Options[] | null;
  };

  export type Lead = {
    __typename?: 'Money';

    formatted: string;
  };

  export type StrikeOut = {
    __typename?: 'Money';

    formatted: string;
  };

  export type Disclaimer = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type PriceMessages = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type MarketingFeeDetails = {
    __typename?: 'MarketingFeeDetails';

    tierName: string;

    tierIcon: string;

    marketingFeeMessage: MarketingFeeMessage;
  };

  export type MarketingFeeMessage = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type Options = {
    __typename?: 'PropertyPriceOption';

    leadingCaption?: string | null;

    displayPrice?: DisplayPrice | null;

    strikeOut?: _StrikeOut | null;

    loyaltyPrice?: LoyaltyPrice | null;

    disclaimer?: _Disclaimer | null;
  };

  export type DisplayPrice = {
    __typename?: 'Money';

    formatted: string;
  };

  export type _StrikeOut = {
    __typename?: 'Money';

    formatted: string;
  };

  export type LoyaltyPrice = {
    __typename?: 'LoyaltyPrice';

    amount?: Amount | null;

    unit?: string | null;
  };

  export type Amount = {
    __typename?: 'FormattedNumber';

    formatted: string;
  };

  export type _Disclaimer = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type Reviews = {
    __typename?: 'PropertyReviewsSummary';

    score?: number | null;

    localizedScore?: string | null;

    total?: number | null;

    localizedTotal?: string | null;

    superlative?: string | null;

    localizedSubtitle?: string | null;
  };

  export type DestinationInfo = {
    __typename?: 'PropertyDestinationInfo';

    distanceFromMessaging?: string | null;
  };

  export type Availability = {
    __typename?: 'PropertyAvailability';

    available: boolean;

    text?: string | null;

    theme?: Theme | null;
  };

  export type OfferSummary = {
    __typename?: 'OfferSummary';

    messages?: Messages[] | null;
  };

  export type Messages = {
    __typename?: 'OfferSummaryMessage';

    message?: string | null;

    theme?: Theme | null;

    type?: string | null;
  };

  export type LegalDisclaimer = {
    __typename?: 'PropertyLegalDisclaimer';

    title?: string | null;

    disclaimerContents?: string[] | null;
  };

  export type Neighborhood = {
    __typename?: 'Region';

    name: string;
  };

  export type RecentlyViewed = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type ShortList = {
    __typename?: 'ShortList';

    favorited: boolean;

    saveUrl: string;

    removeUrl: string;

    metaData: MetaData;

    clickTracking: ClickTracking[];
  };

  export type MetaData = {
    __typename?: 'ShortListMetaData';

    chkIn: string;

    chkOut: string;

    hotelId: string;

    roomConfiguration: string;
  };

  export type ClickTracking = ShoppingGlobalDataInlineFragment | AllHotelProductsDataInlineFragment;

  export type ShoppingGlobalDataInlineFragment = {
    __typename?: 'ShoppingGlobalData';

    schemaName: string;

    messageContent: MessageContent;
  };

  export type MessageContent = {
    __typename?: 'ShoppingGlobal';

    destinationCode: string;

    destinationName?: string | null;

    numAdults?: number | null;

    numChildren?: number | null;

    shoppingHotel: ShoppingHotel;

    tripEndDate?: string | null;

    tripStartDate?: string | null;
  };

  export type ShoppingHotel = {
    __typename?: 'ShoppingHotel';

    numRooms: number;

    rooms: Rooms[];
  };

  export type Rooms = {
    __typename?: 'Rooms';

    childrenAges?: number[] | null;

    numAdults: number;

    numChildren?: number | null;
  };

  export type AllHotelProductsDataInlineFragment = {
    __typename?: 'AllHotelProductsData';

    schemaName: string;

    messageContent: _MessageContent;
  };

  export type _MessageContent = {
    __typename?: 'AllHotelProducts';

    hotelProducts: HotelProducts[];
  };

  export type HotelProducts = {
    __typename?: 'HotelProduct';

    productId: number;

    productType?: string | null;
  };

  export type SponsoredListing = {
    __typename?: 'SponsoredListing';

    id?: string | null;

    clickRedirectTrackingUrl?: Url | null;

    clickTrackingUrl?: Url | null;

    details?: string | null;

    detailsHeadline?: string | null;

    hotelImage?: string | null;

    impressionTrackingUrl?: Url | null;

    trackingData?: string | null;

    brand?: string | null;

    clickRedirectLinkoffTrackingUrl?: Url | null;

    logo?: string | null;

    lotagline?: string | null;

    rating?: string | null;

    slots?: string | null;

    vanityUrl?: Url | null;

    rank?: string | null;

    position?: string | null;
  };

  export type DataAttributes = {
    __typename?: 'GraphQLPair';

    key: string;

    value: string;
  };
}

export namespace RemoveItemFromCart {
  export type Variables = {
    cartId: Uuid;
    context: ContextInput;
    itemId: Uuid;
  };

  export type Mutation = {
    __typename?: 'Mutation';

    cartItems: CartItems;
  };

  export type CartItems = {
    __typename?: 'CartMutations';

    remove: Remove;
  };

  export type Remove = {
    __typename?: 'CartSummary';

    id: Uuid;

    itemCount: number;
  };
}

export namespace TranslateReview {
  export type Variables = {
    context: ContextInput;
    hotelId: string;
    reviewId: string;
    targetLocale?: Locale | null;
  };

  export type Query = {
    __typename?: 'Query';

    propertyInfo: PropertyInfo;
  };

  export type PropertyInfo = {
    __typename?: 'PropertyInfo';

    review?: Review | null;
  };

  export type Review = HotelReview.Fragment;
}

export namespace Reviews {
  export type Variables = {
    context: ContextInput;
    propertyId: string;
    pagination: PaginationInput;
    sortBy: PropertyReviewSort;
    filters: PropertyReviewFiltersInput;
  };

  export type Query = {
    __typename?: 'Query';

    propertyInfo: PropertyInfo;
  };

  export type PropertyInfo = {
    __typename?: 'PropertyInfo';

    reviewInfo: ReviewInfo;
  };

  export type ReviewInfo = {
    __typename?: 'PropertyReviews';

    summary: Summary;

    reviews: Reviews[];

    sortAndFilter: SortAndFilter;
  };

  export type Summary = {
    __typename?: 'PropertyReviewSummary';

    superlative?: string | null;

    totalCount: TotalCount;

    reviewCountLocalized?: string | null;

    averageOverallRating: AverageOverallRating;

    cleanliness: Cleanliness;

    serviceAndStaff: ServiceAndStaff;

    amenityScore?: AmenityScore | null;

    hotelCondition: HotelCondition;

    cleanlinessPercent: number;

    cleanlinessOverMax?: string | null;

    serviceAndStaffPercent: number;

    serviceAndStaffOverMax?: string | null;

    amenityScorePercent?: number | null;

    amenityScoreOverMax?: string | null;

    hotelConditionPercent: number;

    hotelConditionOverMax?: string | null;

    ratingCounts?: RatingCounts[] | null;

    lastIndex: number;

    reviewDisclaimer?: string | null;
  };

  export type TotalCount = {
    __typename?: 'FormattedNumber';

    raw: number;

    formatted: string;
  };

  export type AverageOverallRating = {
    __typename?: 'FormattedNumber';

    raw: number;

    formatted: string;
  };

  export type Cleanliness = {
    __typename?: 'FormattedNumber';

    raw: number;

    formatted: string;
  };

  export type ServiceAndStaff = {
    __typename?: 'FormattedNumber';

    raw: number;

    formatted: string;
  };

  export type AmenityScore = {
    __typename?: 'FormattedNumber';

    raw: number;

    formatted: string;
  };

  export type HotelCondition = {
    __typename?: 'FormattedNumber';

    raw: number;

    formatted: string;
  };

  export type RatingCounts = {
    __typename?: 'PropertyReviewRatingCount';

    count: Count;

    percent: number;

    rating: number;
  };

  export type Count = {
    __typename?: 'FormattedNumber';

    formatted: string;

    raw: number;
  };

  export type Reviews = {
    __typename?: 'PropertyReview';

    id: string;

    ratingOverall: number;

    superlative?: string | null;

    submissionTime: SubmissionTime;

    title: string;

    text: string;

    locale: Locale;

    author?: string | null;

    userLocation: string;

    stayDuration?: string | null;

    helpfulReviewVotes?: string | null;

    negativeRemarks?: string | null;

    positiveRemarks?: string | null;

    locationRemarks?: string | null;

    photos: Photos[];

    managementResponses: ManagementResponses[];

    travelers: string[];

    themes?: Themes[] | null;
  };

  export type SubmissionTime = {
    __typename?: 'DateTime';

    raw: string;
  };

  export type Photos = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type ManagementResponses = {
    __typename?: 'ManagementResponse';

    id?: string | null;

    date?: string | null;

    displayLocale?: string | null;

    userNickname?: string | null;

    response?: string | null;
  };

  export type Themes = {
    __typename?: 'ReviewThemes';

    icon?: Icon | null;

    label?: string | null;
  };

  export type Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type SortAndFilter = {
    __typename?: 'SortAndFilterViewModel';

    sortAndFilter: _SortAndFilter[];
  };

  export type _SortAndFilter = {
    __typename?: 'FilterViewModel';

    name: string;

    label?: string | null;

    options: Options[];
  };

  export type Options = {
    __typename?: 'OptionViewModel';

    label?: string | null;

    isSelected: boolean;

    optionValue?: string | null;
  };
}

export namespace QuestionAnswers {
  export type Variables = {
    context: ContextInput;
    productId: string;
    filters: ProductQuestionFiltersInput;
    pagination: PaginationInput;
    productQuestionTopic: ProductQuestionTopic;
    questionDateFormat: string;
  };

  export type Query = {
    __typename?: 'Query';

    productQuestions?: ProductQuestions | null;
  };

  export type ProductQuestions = {
    __typename?: 'ProductQuestions';

    totalCount?: TotalCount | null;

    questions: Questions[];
  };

  export type TotalCount = {
    __typename?: 'FormattedNumber';

    raw: number;
  };

  export type Questions = {
    __typename?: 'UserQuestion';

    answers?: Answers[] | null;

    createDate?: CreateDate | null;

    id: string;

    question: string;

    questioner?: string | null;

    totalAnswers: TotalAnswers;
  };

  export type Answers = {
    __typename?: 'UserAnswer';

    answer: string;

    answerTime: AnswerTime;

    displayName?: string | null;

    id: string;

    upVotes: UpVotes;
  };

  export type AnswerTime = {
    __typename?: 'DateTime';

    formatted: string;

    raw: string;
  };

  export type UpVotes = {
    __typename?: 'FormattedNumber';

    raw: number;
  };

  export type CreateDate = {
    __typename?: 'DateTime';

    formatted: string;

    raw: string;
  };

  export type TotalAnswers = {
    __typename?: 'FormattedNumber';

    raw: number;
  };
}

export namespace UpvotePropertyReview {
  export type Variables = {
    reviewId: string;
  };

  export type Mutation = {
    __typename?: 'Mutation';

    upvotePropertyReview: string;
  };
}

export namespace SearchLinkMessage {
  export type Fragment = {
    __typename?: 'LodgingLinkMessage';

    link: Link;

    icon?: Icon | null;
  };

  export type Link = SearchLink.Fragment;

  export type Icon = {
    __typename?: 'Icon';

    id: string;
  };
}

export namespace SearchDialogMessage {
  export type Fragment = {
    __typename?: 'LodgingDialogTriggerMessage';

    dialogTrigger: DialogTrigger;

    icon?: Icon | null;
  };

  export type DialogTrigger = {
    __typename?: 'LodgingDialogTrigger';

    dialogName: string;

    referrerId?: string | null;

    actionDetails?: ActionDetails | null;
  };

  export type ActionDetails = {
    __typename?: 'DialogAction';

    linkUrl: string;

    referrerId?: string | null;

    message?: string | null;

    text?: string | null;
  };

  export type Icon = {
    __typename?: 'Icon';

    id: string;
  };
}

export namespace SearchLink {
  export type Fragment = {
    __typename?: 'LodgingLink';

    url: Url;

    referrerId?: string | null;
  };
}

export namespace CommonPropertyCardFields {
  export type Fragment = {
    __typename?: 'Property';

    id: string;

    name: string;

    propertyImage?: PropertyImage | null;

    offerBadge?: OfferBadge | null;

    price?: Price | null;

    reviews: Reviews;

    destinationInfo: DestinationInfo;

    vipMessaging?: string | null;

    infositeURL: string;
  };

  export type PropertyImage = {
    __typename?: 'PropertyImage';

    image: Image;
  };

  export type Image = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type OfferBadge = {
    __typename?: 'OfferBadge';

    primary?: Primary | null;

    secondary?: Secondary | null;
  };

  export type Primary = {
    __typename?: 'Badge';

    text?: string | null;

    theme_temp?: Theme | null;

    icon_temp?: IconTemp | null;
  };

  export type IconTemp = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type Secondary = {
    __typename?: 'Badge';

    text?: string | null;

    theme_temp?: Theme | null;

    icon_temp?: _IconTemp | null;
  };

  export type _IconTemp = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type Price = {
    __typename?: 'PropertyPrice';

    lead?: Lead | null;

    strikeOutType?: StrikeOutType | null;

    strikeOut?: StrikeOut | null;

    disclaimer?: Disclaimer | null;

    roomNightMessage?: string | null;

    priceMessages?: PriceMessages[] | null;

    marketingFeeDetails?: MarketingFeeDetails | null;

    options?: Options[] | null;
  };

  export type Lead = {
    __typename?: 'Money';

    formatted: string;
  };

  export type StrikeOut = {
    __typename?: 'Money';

    formatted: string;
  };

  export type Disclaimer = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type PriceMessages = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type MarketingFeeDetails = {
    __typename?: 'MarketingFeeDetails';

    tierName: string;

    tierIcon: string;

    marketingFeeMessage: MarketingFeeMessage;
  };

  export type MarketingFeeMessage = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type Options = {
    __typename?: 'PropertyPriceOption';

    leadingCaption?: string | null;

    displayPrice?: DisplayPrice | null;

    strikeOut?: _StrikeOut | null;

    loyaltyPrice?: LoyaltyPrice | null;

    disclaimer?: _Disclaimer | null;
  };

  export type DisplayPrice = {
    __typename?: 'Money';

    formatted: string;
  };

  export type _StrikeOut = {
    __typename?: 'Money';

    formatted: string;
  };

  export type LoyaltyPrice = {
    __typename?: 'LoyaltyPrice';

    amount?: Amount | null;

    unit?: string | null;
  };

  export type Amount = {
    __typename?: 'FormattedNumber';

    formatted: string;
  };

  export type _Disclaimer = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type Reviews = {
    __typename?: 'PropertyReviewsSummary';

    score?: number | null;

    localizedScore?: string | null;

    total?: number | null;

    localizedTotal?: string | null;

    superlative?: string | null;

    localizedSubtitle?: string | null;
  };

  export type DestinationInfo = {
    __typename?: 'PropertyDestinationInfo';

    distanceFromMessaging?: string | null;
  };
}

export namespace CommonDateFields {
  export type Fragment = {
    __typename?: 'Date';

    year: number;

    month: number;

    day: number;
  };
}

export namespace CommonDateTimeFields {
  export type Fragment = {
    __typename?: 'DateTime';

    year: number;

    month: number;

    day: number;

    hour: number;

    minute: number;

    second: number;
  };
}

export namespace PointsEducationFragment {
  export type Fragment = {
    __typename?: 'LoyaltyPointsEducation';

    description?: string | null;

    programFeatures: ProgramFeatures[];
  };

  export type ProgramFeatures = {
    __typename?: 'LoyaltyEducationSection';

    description?: string | null;

    perks?: Perks | null;

    title?: string | null;
  };

  export type Perks = PerksFragment.Fragment;
}

export namespace ProgramEducationFragment {
  export type Fragment = {
    __typename?: 'LoyaltyProgramEducation';

    joinProgramText?: string | null;

    perks: Perks;
  };

  export type Perks = PerksFragment.Fragment;
}

export namespace PerksFragment {
  export type Fragment = {
    __typename?: 'LoyaltyEducationPerks';

    descriptions: string[];

    icon?: string | null;
  };
}

export namespace HotelReview {
  export type Fragment = {
    __typename?: 'PropertyReview';

    id: string;

    locale: Locale;

    photos: Photos[];

    ratingOverall: number;

    submissionTime: SubmissionTime;

    text: string;

    title: string;

    userLocation: string;

    userNickname: string;
  };

  export type Photos = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type SubmissionTime = {
    __typename?: 'DateTime';

    raw: string;
  };
}
